<template>
  <div v-if="loading" class="loader">
    <div class="spinner-container">
      <div class="loading_msg">
        <div v-cloak>{{ loading_msg }}</div>
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>
  </div>
  <div v-else-if="!loading">
    <div class="content-block">

      <!-- page 1 – Applicant details -->
      <div class="page" data-page=1 v-if="page==1">
        <section>
          <div class="pd-2 dark">
            <div class="container">
              <h1>What is your name?</h1>
              <label>As it appears on the NSW electoral Roll</label>
              <hr>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group" v-bind:class="{input_error:applicant1.prefix_error}">
                    <label>Prefix</label>
                    <select id="applicant1_prefix" class="form-control" v-model="applicant1.prefix">
                      <option :value="null">Please Select</option>
                      <option v-for="prefix in prefixes" :value="prefix.CODE" :key="prefix.CODE">{{ prefix.CODE }}
                      </option>
                    </select>
                    <span v-if="applicant1.prefix_error" class="error">Please select your prefix</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group" v-bind:class="{input_error:applicant1.first_name_error}">
                    <label>First Name</label>
                    <input id="applicant1_first_name" v-model="applicant1.first_name" type="text" class="form-control">
                    <span v-if="applicant1.first_name_error" class="error">Please enter your first name</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Middle name(s)</label>

                    <input type="text" v-model="applicant1.middle_name" class="form-control"
                           placeholder="Enter if you have one">

                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group" v-bind:class="{input_error:applicant1.last_name_error}">
                    <label>Last Name</label>
                    <input id="applicant1_last_name" v-model="applicant1.last_name" type="text" class="form-control">
                    <span v-if="applicant1.last_name_error" class="error">Please enter your last name</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="pd-2">
            <div class="container">
              <h1>Your Date of Birth </h1>
              <hr>
              <div class="row">
                <div class="text-left col-md-5">
                  <div class="form-group" v-bind:class="{input_error:applicant1.date_of_birth_error}">
                    <label>DOB</label>
                    <div id="applicant1_date_of_birth">
                      <select v-model="applicant1Day">
                        <option value="null" disabled>Day</option>
                        <option v-for="day in applicantDob_days" :value="day">{{ day }}</option>
                      </select>
                      <select v-model="applicant1Month">
                        <option :value="null" disabled>Month</option>
                        <option v-for="month in applicantDob_months" :value="month">{{ month }}</option>
                      </select>
                      <select v-model="applicant1Year">
                        <option :value="null" disabled>Year</option>
                        <option v-for="year in applicantDob_years" :value="year">{{ year }}</option>
                      </select>
                      <!--<vue-datepicker @@selected="updateApp1Dob" :input-class="birth_dates.cls" :calendar-button-icon="birth_dates.icon" :disabled-dates="birth_dates.disabledDates" v-model="applicant1.date_of_birth"></vue-datepicker>-->
                      <span v-if="applicant1.date_of_birth_error" class="error">Please select a valid date</span>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <transition name="fade">
                <div class="row" v-if="is_young_liberal_eligible && !isJoint">
                  <div class="col-md-5">
                    <div class="bt-lh">
                      <label>Would you like to join the Party as a Young Liberal?</label>
                    </div>
                  </div>
                  <div class="col-md-7"><a class="btn btn-primary" v-bind:class="{active:is_young_liberal}"
                                           v-on:click="add_young_liberal">Yes</a> <a class="btn btn-primary"
                                                                                     v-bind:class="{active:is_not_young_liberal}"
                                                                                     v-on:click="remove_young_liberal">No</a>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </section>
        <section v-if="!is_young_liberal">
          <div class="pd-2 dark">
            <div class="container">
              <div class="row">
                <div class="col-md-5">
                  <div class="bt-lh">
                    <label>Are you applying for single or joint membership?</label>
                  </div>
                </div>
                <div class="col-md-7">
                  <a id="btn-single-applicant" class="btn btn-primary" v-bind:class="{active:isSingle}"
                     v-on:click="single_applicant">Single</a>
                  <a id="btn-joint-applicant" class="btn btn-primary" v-bind:class="{active:isJoint}"
                     v-on:click="joint_applicant">Joint</a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <transition name="fade">
          <div v-if="isJoint">
            <section>
              <div class="pd-2">
                <div class="container">
                  <h1>What is the second applicant's name?</h1>
                  <label>As it appears on the NSW electoral Roll</label>
                  <hr>
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group" v-bind:class="{input_error:applicant2.prefix_error}">
                        <label>Prefix</label>
                        <select id="applicant2_prefix" class="form-control" v-model="applicant2.prefix">
                          <option :value="null">Please Select</option>
                          <option v-for="prefix in prefixes" :value="prefix.CODE" :key="prefix.CODE">{{ prefix.CODE }}
                          </option>
                        </select>
                        <span v-if="applicant2.prefix_error" class="error">Please select second applicant prefix</span>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group" v-bind:class="{input_error:applicant2.first_name_error}">
                        <label>First Name</label>
                        <input id="applicant2_first_name" v-model="applicant2.first_name" type="text"
                               class="form-control">
                        <span v-if="applicant2.first_name_error"
                              class="error">Please enter second applicant first name</span>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label>Middle name(s)</label>
                        <input type="text" v-model="applicant2.middle_name" class="form-control"
                               placeholder="Enter if you have one">
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group" v-bind:class="{input_error:applicant2.last_name_error}">
                        <label>Last Name</label>
                        <input id="applicant2_last_name" v-model="applicant2.last_name" type="text"
                               class="form-control">
                        <span v-if="applicant2.last_name_error"
                              class="error">Please enter second applicant last name</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <div class="pd-2 dark">
                <div class="container">
                  <h1>What is <span class="txtcap">{{ applicant2.first_name || 'the second applicant' }}’s</span> Date
                    of Birth?</h1>
                  <hr>
                  <div class="row">
                    <div class="col-md-5">
                      <div class="form-group" v-bind:class="{input_error:applicant2.date_of_birth_error}">
                        <label>DOB</label>
                        <div id="applicant2_date_of_birth">
                          <select v-model="applicant2Day">
                            <option value="null" disabled>Day</option>
                            <option v-for="day in applicantDob_days" :value="day" :key="day">{{ day }}</option>
                          </select>
                          <select v-model="applicant2Month">
                            <option value="null" disabled>Month</option>
                            <option v-for="month in applicantDob_months" :value="month" :key="month">{{ month }}
                            </option>
                          </select>
                          <select v-model="applicant2Year">
                            <option value="null" disabled>Year</option>
                            <option v-for="year in applicantDob_years" :value="year" :key="year">{{ year }}</option>
                          </select>
                          <!--<vue-datepicker @@selected="updateApp2Dob" :input-class="birth_dates.cls" :calendar-button-icon="birth_dates.icon" :disabled-dates="birth_dates.disabledDates" v-model="applicant2.date_of_birth"></vue-datepicker>-->
                          <span v-if="applicant2.date_of_birth_error" class="error">Please select a valid date</span>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </transition>
        <section>
          <div class="pd-2 dark">
            <div class="container">
              <h1><span class="txtcap">{{ applicant1.first_name || 'First Applicant' }}’s</span> Contact Information</h1>
              <hr>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.email_error}">
                    <label>Email</label>

                    <input id="applicant1_email" v-model="applicant1.email" type="text" class="form-control">
                    <span v-if="applicant1.email_error" class="error">Please enter a valid email</span>

                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.mobile_phone_error}">
                    <label>Mobile number</label>
                    <input id="applicant1_mobile_phone" v-model="applicant1.mobile_phone" type="text" placeholder=""
                           class="form-control">
                    <span v-if="applicant1.mobile_phone_error" class="error">Please enter your mobile phone</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.home_phone_error}">
                    <label>Home number</label>
                    <input id="applicant1_home_phone" v-model="applicant1.home_phone" type="text"
                           placeholder="Enter if you have one" class="form-control">
                    <span v-if="applicant1.home_phone_error" class="error">Please enter your home phone</span>
                  </div>
                </div>

              </div>
              <p v-if="applicant1.address.validate_errormob" class="input_error">
                <strong>You must enter in a valid Australian mobile number, if you do not have one then please complete
                  a manual join form or call 02 8356 0300.</strong>
              </p>
              <hr>
              <div v-if="isJoint">

                <h1><span class="txtcap">{{ applicant2.first_name || 'Second applicant' }}’s</span> Contact Information
                </h1>
                <hr>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.email_error}">
                      <label>Email</label>

                      <input id="applicant2_email" type="text" class="form-control" v-model="applicant2.email">
                      <span v-if="applicant2.email_error" class="error">Please enter a valid email</span>

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.mobile_phone_error}">
                      <label>Mobile number</label>
                      <input id="applicant2_mobile_phone" type="text" placeholder="" class="form-control"
                             v-model="applicant2.mobile_phone">
                      <span v-if="applicant2.mobile_phone_error" class="error">Please enter <span
                          class="txtcap">{{ applicant2.first_name }}</span><span v-if="applicant2.first_name">'s</span> mobile phone</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.home_phone_error}">
                      <label>Home number</label>
                      <input id="applicant2_home_phone" type="text" placeholder="Enter if you have one"
                             class="form-control" v-model="applicant2.home_phone">
                      <span v-if="applicant2.home_phone_error" class="error">Please enter <span
                          class="txtcap">{{ applicant2.first_name }}</span><span v-if="applicant2.first_name">'s</span> home phone</span>
                    </div>
                  </div>

                </div>
                <p v-if="applicant2.address.validate_errormob" class="input_error">
                  <strong>You must enter in a valid Australian mobile number, if you do not have one then please
                    complete a manual join form or call 02 8356 0300.</strong>
                </p>
              </div>

            </div>
          </div>


        </section>
        <section>
          <div class="pd-2 dark">
            <div class="container">
              <h1>Your Electoral Roll Details</h1>
              <h3 class="txtcap">{{ applicant1.first_name }}</h3>
              <label id="address1-validate">Electoral Roll Address</label>
              <hr>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.address.street_number_error}">
                    <label>Unit No and/or Street No</label>

                    <input maxlength="40" id="applicant1_street_number" v-model="applicant1.address.street_number"
                           type="text" class="form-control">
                    <span v-if="applicant1.address.street_number_error"
                          class="error">Please enter your street number</span>

                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group" v-bind:class="{input_error:applicant1.address.street_name_error}">
                    <label>Street name</label>

                    <input id="applicant1_street_name" v-model="applicant1.address.street_name" type="text"
                           class="form-control">
                    <span v-if="applicant1.address.street_name_error" class="error">Please enter your street name</span>

                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group" v-bind:class="{input_error:applicant1.address.street_type_error}">
                    <label>Street type</label>
                    <select id="applicant1_street_type" class="form-control" v-model="applicant1.address.street_type">
                      <option :value="null">Please Select</option>
                      <option value="None">None</option>
                      <option v-for="street_type in street_types" :value="street_type.CODE">{{ street_type.CODE }}
                      </option>
                    </select>
                    <span v-if="applicant1.address.street_type_error" class="error">Please enter your street type</span>

                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.address.suburb_error}">
                    <label>Suburb</label>

                    <input id="applicant1_suburb" type="text" class="form-control" v-model="applicant1.address.suburb">
                    <span v-if="applicant1.address.suburb_error" class="error">Please enter your suburb</span>

                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.address.state_error}">
                    <label>State</label>

                    <select id="applicant1_state" class="form-control" v-model="applicant1.address.state">
                      <option value="">Select State</option>
                      <option value="ACT">ACT</option>
                      <option value="NSW">NSW</option>
                      <option value="NT">NT</option>
                      <option value="QLD">QLD</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="VIC">VIC</option>
                      <option value="WA">WA</option>
                    </select>
                    <span v-if="applicant1.address.state_error" class="error">Please enter your state</span>

                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.address.post_code_error}">
                    <label>Postcode</label>

                    <input id="applicant1_post_code" type="text" class="form-control"
                           v-model="applicant1.address.post_code">
                    <span v-if="applicant1.address.post_code_error" class="error">Please enter your postcode</span>

                  </div>
                </div>
              </div>
              <p v-if="applicant1.address.validate_error" class="input_error">
                <strong>We haven't been able to verify that your name matches your electoral roll address, please ensure
                  you have entered your electoral roll address and name correctly. To check your Electoral Roll address
                  please go to:<a href="https://check.aec.gov.au/" target="_blank">
                    https://check.aec.gov.au/</a></strong>
              </p>
              <p v-if="applicant1.address.validate_errorelectoral2" class="input_error">
                <strong>We haven't been able to verify that your name matches your electoral roll address, please
                  contact us on (02) 8356 0300 during office hours to continue your application.</strong>
              </p>
              <p v-if="applicant1.address.validate_duplicate" class="input_error">
                <strong>You are not able to complete the application process. Please contact (02) 8356 0300 to discuss
                  your application.</strong>
              </p>

              <hr>

              <div v-if="isJoint">
                <h3 class="txtcap">{{ applicant2.first_name }}</h3>

                <div class="checkbox">
                  <label>
                    <input type="checkbox" id="same_address" v-model="applicant2.address.same_as">
                    Please tick this box if your electoral roll details are the same as above.
                  </label>
                </div>
                <label>Electoral Roll Address</label>
                <hr>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.address.street_number_error}">
                      <label>Unit No and/or Street No</label>

                      <input :disabled="applicant2.address.same_as" id="applicant2_street_number"
                             v-model="applicant2.address.street_number" type="text" class="form-control" maxlength="40">
                      <span v-if="applicant2.address.street_number_error"
                            class="error">Please enter your street number</span>

                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group" v-bind:class="{input_error:applicant2.address.street_name_error}">
                      <label>Street name</label>

                      <input :disabled="applicant2.address.same_as" id="applicant2_street_name" type="text"
                             class="form-control" v-model="applicant2.address.street_name">
                      <span v-if="applicant2.address.street_name_error"
                            class="error">Please enter your street name</span>

                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group" v-bind:class="{input_error:applicant2.address.street_type_error}">
                      <label>Street type</label>
                      <select :disabled="applicant2.address.same_as" id="applicant2_street_type" class="form-control"
                              v-model="applicant2.address.street_type">
                        <option :value="null">Please Select</option>
                        <option value="None">None</option>
                        <option v-for="street_type in street_types" :value="street_type.CODE">{{ street_type.CODE }}
                        </option>
                      </select>
                      <span v-if="applicant2.address.street_type_error"
                            class="error">Please enter your street type</span>

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.address.suburb_error}">
                      <label>Suburb</label>

                      <input :disabled="applicant2.address.same_as" id="applicant2_suburb" type="text"
                             class="form-control" v-model="applicant2.address.suburb">
                      <span v-if="applicant2.address.suburb_error" class="error">Please enter your suburb</span>

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.address.state_error}">
                      <label>State</label>

                      <select :disabled="applicant2.address.same_as" id="applicant2_state" class="form-control"
                              v-model="applicant2.address.state">
                        <option value="">Select State</option>
                        <option value="ACT">ACT</option>
                        <option value="NSW">NSW</option>
                        <option value="NT">NT</option>
                        <option value="QLD">QLD</option>
                        <option value="SA">SA</option>
                        <option value="TAS">TAS</option>
                        <option value="VIC">VIC</option>
                        <option value="WA">WA</option>
                      </select>
                      <span v-if="applicant2.address.state_error" class="error">Please enter your state</span>

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.address.post_code_error}">
                      <label>Postcode</label>

                      <input :disabled="applicant2.address.same_as" id="applicant2_post_code" type="text"
                             class="form-control" v-model="applicant2.address.post_code">
                      <span v-if="applicant2.address.post_code_error" class="error">Please enter your postcode</span>

                    </div>
                  </div>
                </div>
                <p v-if="applicant2.address.validate_error" class="input_error">
                  <strong>We haven't been able to verify that your name matches your electoral role address, please
                    ensure you have entered your electoral role address and name correctly. To check your Electoral Roll
                    address please go to:<a href="https://check.aec.gov.au/" target="_blank">
                      https://check.aec.gov.au/</a></strong>
                </p>
                <p v-if="applicant2.address.validate_errorelectoral2" class="input_error">
                  <strong>We haven't been able to verify that your name matches your electoral role address, please
                    contact us on (02) 8356 0300 during office hours to continue your application.</strong>
                </p>
                <p v-if="applicant2.address.validate_duplicate" class="input_error">
                  <strong>You are not able to complete the application process. Please contact (02) 8356 0300 to discuss
                    your application.</strong>
                </p>

              </div>

            </div>
          </div>
        </section>
        <section>
          <div class="pd-2 dark">
            <div class="container">
              <h1>Your Postal Address Details</h1>
              <h3 class="txtcap">{{ applicant1.first_name }}</h3>
              <div class="checkbox">
                <label>
                  <input type="checkbox" id="same_postaladdress1" v-model="applicant1.postaladdress.same_as">
                  Please tick this box if your postal address same as electoral roll details as above.
                </label>
              </div>
              <label>Postal Address</label>
              <hr>
              <div class="checkbox">
                <label>
                  <input type="checkbox" id="applicant1_chkuse_pobox" v-model="applicant1.postaladdress.use_pobox">
                  My postal address is a PO Box address
                </label>
              </div>

              <section id="applicant1_pobox_street" v-if="!applicant1.postaladdress.use_pobox">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant1.postaladdress.street_number_error}">
                      <label>Unit No and/or Street No</label>

                      <input :disabled="applicant1.postaladdress.same_as" maxlength="40"
                             id="applicant1_postaladdress_street_number"
                             v-model="applicant1.postaladdress.street_number" type="text" class="form-control">
                      <span v-if="applicant1.postaladdress.street_number_error" class="error">Please enter your street number</span>

                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group" v-bind:class="{input_error:applicant1.postaladdress.street_name_error}">
                      <label>Street name</label>

                      <input :disabled="applicant1.postaladdress.same_as" id="applicant1_postaladdress_street_name"
                             v-model="applicant1.postaladdress.street_name" type="text" class="form-control">
                      <span v-if="applicant1.postaladdress.street_name_error" class="error">Please enter your street name</span>

                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group" v-bind:class="{input_error:applicant1.postaladdress.street_type_error}">
                      <label>Street type</label>
                      <select :disabled="applicant1.postaladdress.same_as" id="applicant1_postaladdress_street_type"
                              class="form-control" v-model="applicant1.postaladdress.street_type">
                        <option :value="null">Please Select</option>
                        <option value="None">None</option>
                        <option v-for="street_type in street_types" :value="street_type.CODE">{{ street_type.CODE }}
                        </option>
                      </select>
                      <span v-if="applicant1.postaladdress.street_type_error" class="error">Please enter your street type</span>

                    </div>
                  </div>
                </div>
              </section>
              <section id="applicant1_pobox_address1" v-if="applicant1.postaladdress.use_pobox">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group" v-bind:class="{input_error:applicant1.postaladdress.address1_error}">
                      <label>PO Box Details</label>
                      <input maxlength="100" id="applicant1_postaladdress_address"
                             v-model="applicant1.postaladdress.address1" type="text" class="form-control">
                      <span v-if="applicant1.postaladdress.address1_error" class="error">Please enter your PO Box details</span>

                    </div>
                  </div>
                </div>
              </section>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.postaladdress.suburb_error}">
                    <label>Suburb</label>

                    <input :disabled="applicant1.postaladdress.same_as" id="applicant1_postaladdress_suburb" type="text"
                           class="form-control" v-model="applicant1.postaladdress.suburb">
                    <span v-if="applicant1.postaladdress.suburb_error" class="error">Please enter your suburb</span>

                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.postaladdress.state_error}">
                    <label>State</label>

                    <select :disabled="applicant1.postaladdress.same_as" id="applicant1_postaladdress_state"
                            class="form-control" v-model="applicant1.postaladdress.state">
                      <option value="">Select State</option>
                      <option value="ACT">ACT</option>
                      <option value="NSW">NSW</option>
                      <option value="NT">NT</option>
                      <option value="QLD">QLD</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="VIC">VIC</option>
                      <option value="WA">WA</option>
                    </select>
                    <span v-if="applicant1.postaladdress.state_error" class="error">Please enter your state</span>

                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group" v-bind:class="{input_error:applicant1.postaladdress.post_code_error}">
                    <label>Postcode</label>

                    <input :disabled="applicant1.postaladdress.same_as" id="applicant1_postaladdress_post_code"
                           type="text" class="form-control" v-model="applicant1.postaladdress.post_code">
                    <span v-if="applicant1.postaladdress.post_code_error"
                          class="error">Please enter your postcode</span>

                  </div>
                </div>
              </div>

              <p v-if="applicant1.postaladdress.validate_error" class="input_error">
                <strong>We haven't been able to verify that your name matches your electoral role address, please ensure
                  you have entered your electoral role address and name correctly. To check your Electoral Roll address
                  please go to:<a href="https://check.aec.gov.au/" target="_blank">
                    https://check.aec.gov.au/</a></strong>
              </p>
              <p v-if="applicant1.postaladdress.validate_errorelectoral2" class="input_error">
                <strong>We haven't been able to verify that your name matches your electoral role address, please
                  contact us on (02) 8356 0300 during office hours to continue your application.</strong>
              </p>
              <p v-if="applicant1.postaladdress.validate_duplicate" class="input_error">
                <strong>You are not able to complete the application process. Please contact (02) 8356 0300 to discuss
                  your application.</strong>
              </p>
              <hr>

              <div v-if="isJoint">
                <h3 class="txtcap">{{ applicant2.first_name }}</h3>

                <div class="checkbox">
                  <label>
                    <input type="checkbox" id="same_postaladdress2" v-model="applicant2.postaladdress.same_as">
                    Please tick this box if your postal address same as electoral roll details as above.
                  </label>
                </div>
                <label>Postal Address</label>
                <hr>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" id="applicant2_chkuse_pobox" v-model="applicant2.postaladdress.use_pobox">
                    My postal address is a PO Box address
                  </label>
                </div>
                <section id="applicant2_pobox_street" v-if="!applicant2.postaladdress.use_pobox">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group" v-bind:class="{input_error:applicant2.postaladdress.street_number_error}">
                        <label>Unit No and/or Street No</label>

                        <input :disabled="applicant2.postaladdress.same_as" id="applicant2_postaladdress_street_number"
                               v-model="applicant2.postaladdress.street_number" type="text" class="form-control"
                               maxlength="40">
                        <span v-if="applicant2.postaladdress.street_number_error" class="error">Please enter your street number</span>

                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group" v-bind:class="{input_error:applicant2.postaladdress.street_name_error}">
                        <label>Street name</label>

                        <input :disabled="applicant2.postaladdress.same_as" id="applicant2_postaladdress_street_name"
                               type="text" class="form-control" v-model="applicant2.postaladdress.street_name">
                        <span v-if="applicant2.postaladdress.street_name_error" class="error">Please enter your street name</span>

                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group" v-bind:class="{input_error:applicant2.postaladdress.street_type_error}">
                        <label>Street type</label>
                        <select :disabled="applicant2.postaladdress.same_as" id="applicant2_postaladdress_street_type"
                                class="form-control" v-model="applicant2.postaladdress.street_type">
                          <option :value="null">Please Select</option>
                          <option value="None">None</option>
                          <option v-for="street_type in street_types" :value="street_type.CODE">{{ street_type.CODE }}
                          </option>
                        </select>
                        <span v-if="applicant2.postaladdress.street_type_error" class="error">Please enter your street type</span>

                      </div>
                    </div>
                  </div>
                </section>
                <section id="applicant2_pobox_address1" v-if="applicant2.postaladdress.use_pobox">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group" v-bind:class="{input_error:applicant2.postaladdress.address1_error}">
                        <label>PO Box Details</label>
                        <input maxlength="100" id="applicant2_postaladdress_address"
                               v-model="applicant2.postaladdress.address1" type="text" class="form-control">
                        <span v-if="applicant2.postaladdress.address1_error" class="error">Please enter your PO Box details</span>

                      </div>
                    </div>
                  </div>
                </section>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.postaladdress.suburb_error}">
                      <label>Suburb</label>

                      <input :disabled="applicant2.postaladdress.same_as" id="applicant2_postaladdress_suburb"
                             type="text" class="form-control" v-model="applicant2.postaladdress.suburb">
                      <span v-if="applicant2.postaladdress.suburb_error" class="error">Please enter your suburb</span>

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.postaladdress.state_error}">
                      <label>State</label>

                      <select :disabled="applicant2.postaladdress.same_as" id="applicant2_postaladdress_state"
                              class="form-control" v-model="applicant2.postaladdress.state">
                        <option value="">Select State</option>
                        <option value="ACT">ACT</option>
                        <option value="NSW">NSW</option>
                        <option value="NT">NT</option>
                        <option value="QLD">QLD</option>
                        <option value="SA">SA</option>
                        <option value="TAS">TAS</option>
                        <option value="VIC">VIC</option>
                        <option value="WA">WA</option>
                      </select>
                      <span v-if="applicant2.postaladdress.state_error" class="error">Please enter your state</span>

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-bind:class="{input_error:applicant2.postaladdress.post_code_error}">
                      <label>Postcode</label>

                      <input :disabled="applicant2.postaladdress.same_as" id="applicant2_postaladdress_post_code"
                             type="text" class="form-control" v-model="applicant2.postaladdress.post_code">
                      <span v-if="applicant2.postaladdress.post_code_error"
                            class="error">Please enter your postcode</span>

                    </div>
                  </div>
                </div>
                <p v-if="applicant2.postaladdress.validate_error" class="input_error">
                  <strong>We haven't been able to verify that your name matches your electoral role address, please
                    ensure you have entered your electoral role address and name correctly. To check your Electoral Roll
                    address please go to:<a href="https://check.aec.gov.au/" target="_blank">
                      https://check.aec.gov.au/</a></strong>
                </p>
                <p v-if="applicant2.postaladdress.validate_errorelectoral2" class="input_error">
                  <strong>We haven't been able to verify that your name matches your electoral role address, please
                    contact us on (02) 8356 0300 during office hours to continue your application.</strong>
                </p>
                <p v-if="applicant2.postaladdress.validate_duplicate" class="input_error">
                  <strong>You are not able to complete the application process. Please contact (02) 8356 0300 to discuss
                    your application.</strong>
                </p>

              </div>

            </div>
          </div>
        </section>
        <p v-if="validate_member" class="input_error">
          <strong>You are not able to complete the application process. Please contact (02) 8356 0300 to discuss your
            application.</strong>
        </p>
      </div>

      <!--page 2 – Declaration -->
      <div class="page" data-page=2 v-if="page==2">
        <section>
          <div class="pd-2">
            <div class="container">
              <h1><span class="txtcap">{{ applicant1.first_name }}</span>, please read below carefully and confirm</h1>
              <hr>
              <div class="form-group" v-bind:class="{input_error:applicant1.dec_1_error}">
                <div class="checkbox">

                  <label>
                    <input id="applicant1_dec_1" type="checkbox" v-model="applicant1.dec_1">
                    I declare that I am not a member, present or past, of another political party.
                  </label>

                </div>
              </div>
              <div class="form-group" v-bind:class="{input_error:applicant1.dec_2_error}">
                <div class="checkbox">
                  <label>

                    <input id="applicant1_dec_2" type="checkbox" v-model="applicant1.dec_2">
                    I declare that I have never stood against, or assisted someone who stood against a Liberal endorsed
                    Candidate in a Federal, State or Local Government election.
                  </label>


                </div>
              </div>
              <div class="form-group">
                <div>
                  <label>
                    If you are unable to make these declarations you are unable to proceed with your application online.
                    Please contact us on 02 8356 0300 during office hours.
                  </label>

                </div>
              </div>

              <hr>

              <div v-if="isJoint">


                <h1><span class="txtcap">{{ applicant2.first_name }}</span>, please read below carefully and confirm
                </h1>
                <hr>
                <div class="form-group" v-bind:class="{input_error:applicant2.dec_1_error}">
                  <div class="checkbox">

                    <label>
                      <input id="applicant2_dec_1" type="checkbox" v-model="applicant2.dec_1">
                      I declare that I am not a member, present or past, of another political party.
                    </label>

                  </div>
                </div>
                <div class="form-group" v-bind:class="{input_error:applicant2.dec_2_error}">
                  <div class="checkbox">
                    <label>

                      <input id="applicant2_dec_2" type="checkbox" v-model="applicant2.dec_2">
                      I declare that I have never stood against, or assisted someone who stood against a Liberal
                      endorsed Candidate in a Federal, State or Local Government election.
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <div>
                    <label>
                      If you are unable to make these declarations you are unable to proceed with your application
                      online. Please contact us on 02 8356 0300 during office hours.
                    </label>

                  </div>
                </div>

              </div>


            </div>
          </div>


        </section>

      </div>

      <!--page 3 – Choose membership -->
      <div class="page" data-page=3 v-if="page==3">
        <section>
          <div class="pd-2 dark">
            <div class="container">
              <h1>Please choose your level of Membership:</h1>
              <hr>
              <label v-if="isJoint">Please note, the below prices are for the joint membership of you and your
                partner.</label>

              <div v-for="product in products">
                <div v-if="applicant1.years<=product.age_limit && product.can_show">
                  <div class="row">
                    <div class="col-md-6">
                      <label v-if="!isJoint"> {{ product.product_description }} </label>
                      <label v-if="isJoint&&product.can_joint"> {{ product.product_description }} </label>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox text-right">
                        <label v-if="!isJoint">
                          <input type="radio" v-model="applicant1.picked" v-on:change="updateProducts"
                                 v-bind:value="product.product_code">
                          ${{ product.price }}
                        </label>
                        <label v-if="isJoint&&product.can_joint">
                          <input type="radio" v-model="applicant1.picked" v-on:change="updateProducts"
                                 v-bind:value="product.product_code">
                          ${{ product.price * 2 }}
                        </label>
                      </div>
                    </div>
                    <div v-if="isJoint&&product.can_joint" class="col-md-3" style="display:none !important">
                      <div class="checkbox text-right">
                        <label>
                          <input type="radio" v-model="applicant2.picked" v-on:change="updateProducts"
                                 v-bind:value="product.product_code">
                          ${{ product.price }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <hr>
                </div>
              </div>
              <div v-if="applicant1.picked_error" class="error">
                <p class="bg-danger">
                  Please select <span class="txtcap">{{ applicant1.first_name }}</span> membership
                </p>
              </div>
              <div v-if="applicant2.picked_error" class="error">
                <p class="bg-danger">
                  Please select <span class="txtcap">{{ applicant2.first_name }}</span> membership
                </p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="pd-2">
            <div class="container">
              <h1 v-if="applicant1.is_concession||applicant2.is_concession">Retired superannuants, Pensioners and
                Students must provide proof to gain concession rates.</h1>

              <div v-if="applicant1.is_concession">
                <div class="form-group" v-bind:class="{input_error:applicant1.files[0].error}">
                  <label><span class="txtcap">{{ applicant1.first_name }}</span>, please upload your proof of concession
                    here</label>
                  <input type="file" v-on:change="fileSelected" accept="image/*,application/pdf"
                         id="applicant1_concession">
                  <span v-if="applicant1.files[0].error" class="error">Please select a file</span>
                  <div v-if="applicant1.files[0].blob">
                    <p>
                      <img :src="applicant1.files[0].blob" width="300px" class="img">
                    </p>
                  </div>

                </div>
              </div>
              <div v-if="applicant2.is_concession&&isJoint">
                <div class="form-group" v-bind:class="{input_error:applicant2.files[0].error}">
                  <label><span class="txtcap">{{ applicant2.first_name }}</span>, please upload your proof of concession
                    here</label>

                  <input type="file" v-on:change="fileSelected" accept="image/*,application/pdf"
                         id="applicant2_concession">
                  <span v-if="applicant2.files[0].error" class="error">Please select a file</span>
                  <div v-if="applicant2.files[0].blob">
                    <p>
                      <img :src="this.applicant2.files[0].blob" width="300px" class="img">
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!--page 4 – Branch selection -->
      <div class="page" data-page=4 v-if="page==4">
        <section>
          <div class="pd-2 dark">
            <div class="container">
              <h1>Membership Options</h1>
              <hr>
              <h3 class="txtcap">{{ applicant1.first_name }}</h3>
              <div class="form-group" v-bind:class="{input_error:applicant1.branch_type_error}">
                <div class="row">
                  <div class="col-md-3">
                    <label> I would like to join as a </label>
                  </div>
                  <div class="col-md-9">
                    <label class="radio-inline" v-if="applicant1.branches.length>0">
                      <input type="radio" v-model="applicant1.branch_type" value="branch">
                      Branch Member
                    </label>
                    <label class="radio-inline">
                      <input type="radio" v-model="applicant1.branch_type"
                             :checked="applicant1.branch_type == 'general'" value="general">
                      General Member
                    </label>
                  </div>
                </div>
                <span v-if="applicant1.branch_type_error" class="error">Please select a branch type</span>
                <hr>
              </div>

              <div v-if="isJoint">
                <h3 class="txtcap">{{ applicant2.first_name }}</h3>
                <div class="form-group" v-bind:class="{input_error:applicant2.branch_type_error}">
                  <div class="row">
                    <div class="col-md-3">
                      <label> I would like to join as a </label>
                    </div>
                    <div class="col-md-9">
                      <label v-if="applicant2.branches.length>0" class="radio-inline">
                        <input type="radio" v-model="applicant2.branch_type" value="branch">
                        Branch Member
                      </label>
                      <label class="radio-inline">
                        <input type="radio" v-model="applicant2.branch_type" value="general">
                        General Member
                      </label>
                    </div>
                  </div>
                  <span v-if="applicant2.branch_type_error" class="error">Please select a branch type</span>
                </div>

              </div>
            </div>
          </div>

          <div v-if="applicant1.branch_type=='branch'||applicant2.branch_type=='branch'" class="pd-2">
            <div class="container">
              <h1>Membership Options</h1>
              <hr>
              <transition name="fade">
                <div v-if="applicant1.branch_type=='branch'">
                  <h3 class="txtcap">{{ applicant1.first_name }}</h3>
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group" v-bind:class="{input_error:applicant1.branch_code_error}">
                        <label>I would like to apply to join the</label>
                        <select class="form-control" v-model="applicant1.branch_code">
                          <option :value="null">Please Select</option>
                          <option v-for="branch in applicant1.branches" :value="branch.branch_code">
                            {{ branch.branch_name }}
                          </option>
                        </select>
                        <span v-if="applicant1.branch_code_error" class="error">Please select a branch</span>

                      </div>
                    </div>
                  </div>
                  <hr>
                </div>
              </transition>
              <transition name="fade">
                <div v-if="applicant2.branch_type=='branch'">
                  <h3 class="txtcap">{{ applicant2.first_name }}</h3>
                  <div v-if="isJoint">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group" v-bind:class="{input_error:applicant2.branch_code_error}">
                          <label>I would like to apply to join the</label>
                          <select class="form-control" v-model="applicant2.branch_code">
                            <option :value="null">Please Select</option>
                            <option v-for="branch in applicant2.branches" :value="branch.branch_code">
                              {{ branch.branch_name }}
                            </option>
                          </select>
                          <span v-if="applicant2.branch_code_error" class="error">Please select a branch</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </section>
      </div>

      <!--page 5 – Declaration 2 -->
      <div class="page" data-page=5 v-if="page==5">
        <section>
          <div class="pd-2 dark">
            <div class="container">
              <h1>Membership Declaration</h1>
              <hr>
              <h3 class="txtcap">{{ applicant1.first_name }}</h3>

              <div v-bind:class="{input_error:applicant1.dec_prohibited_funding_error}" class="form-group">
                <div class="row">
                  <div class="col-md-9">
                    <label>Are you a prohibited donor under the Electoral Funding Act 2018? <br/> <a
                        href="https://www.elections.nsw.gov.au/Funding-and-disclosure/Political-donations/Unlawful-political-donations/Prohibited-donors"
                        target="_blank">Click here</a> to find out more.</label>
                  </div>
                  <div class="col-md-3">
                    <div class="checkbox">
                      <label>
                        <input type="radio" v-model="applicant1.dec_prohibited_funding" value="yes">
                        Yes
                      </label>
                    </div>
                    <div class="checkbox">
                      <label>
                        <input type="radio" v-model="applicant1.dec_prohibited_funding" value="no">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <hr>


              <div v-bind:class="{input_error:applicant1.dec_lobbyist_error}" class="form-group">
                <div class="row">
                  <div class="col-md-9">
                    <label>Are you a lobbyist registered under the NSW Register of Third Party Lobbyists or the
                      Australian Government Register of Lobbyists?</label>
                  </div>
                  <div class="col-md-3">
                    <div class="checkbox">
                      <label>
                        <input type="radio" v-model="applicant1.dec_lobbyist" value="yes">
                        Yes
                      </label>
                    </div>
                    <div class="checkbox">
                      <label>
                        <input type="radio" v-model="applicant1.dec_lobbyist" value="no">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div v-bind:class="{input_error:applicant1.dec_previous_member_error}" class="form-group">
                <div class="row">
                  <div class="col-md-9">
                    <label>Have you previously been a member of the Liberal Party of Australia?</label>
                  </div>
                  <div class="col-md-3">
                    <div class="checkbox">
                      <label>
                        <input type="radio" v-model="applicant1.dec_previous_member" value="yes">
                        Yes
                      </label>
                    </div>
                    <div class="checkbox">
                      <label>
                        <input type="radio" v-model="applicant1.dec_previous_member" value="no">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div v-if="applicant1.dec_previous_member=='yes'"
                   v-bind:class="{input_error:applicant1.dec_suspended_error}" class="form-group">
                <div class="row">
                  <div class="col-md-9">
                    <label>If so, have you ever been suspended or expelled from the Party?</label>
                  </div>
                  <div class="col-md-3">
                    <div class="checkbox">
                      <label>
                        <input type="radio" v-model="applicant1.dec_suspended" value="yes">
                        Yes
                      </label>
                    </div>
                    <div class="checkbox">
                      <label>
                        <input type="radio" v-model="applicant1.dec_suspended" value="no">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="applicant1.dec_suspended=='yes'" class="form-group"
                   v-bind:class="{input_error:applicant1.dec_suspendedmsg_error}">
                <div class="row">
                  <div class="col-md-12">
                    <label>If you answered yes, please provide details.</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <input id="applicant1_dec_suspendedmsg" v-model="applicant1.dec_suspendedmsg" type="text"
                           class="form-control">
                    <span v-if="applicant1.dec_suspendedmsg_error" class="error">Please provide details</span>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
        <div v-if="isJoint">
          <section>
            <div class="pd-2">
              <div class="container">
                <h3 class="txtcap">{{ applicant2.first_name }}</h3>

                <div v-bind:class="{input_error:applicant2.dec_prohibited_funding_error}" class="form-group">
                  <div class="row">
                    <div class="col-md-9">
                      <label>Are you a prohibited donor under the Electoral Funding Act 2018? <br/> <a
                          href="https://www.elections.nsw.gov.au/Funding-and-disclosure/Political-donations/Unlawful-political-donations/Prohibited-donors"
                          target="_blank">Click here</a> to find out more.</label>
                    </div>
                    <div class="col-md-3">
                      <div class="checkbox">
                        <label>
                          <input type="radio" v-model="applicant2.dec_prohibited_funding" value="yes">
                          Yes
                        </label>
                      </div>
                      <div class="checkbox">
                        <label>
                          <input type="radio" v-model="applicant2.dec_prohibited_funding" value="no">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>


                <div v-bind:class="{input_error:applicant2.dec_lobbyist_error}" class="form-group">
                  <div class="row">
                    <div class="col-md-9">
                      <label>Are you a lobbyist registered under the NSW Register of Third Party Lobbyists or the
                        Australian Government Register of Lobbyists?</label>
                    </div>
                    <div class="col-md-3">
                      <div class="checkbox">
                        <label>
                          <input type="radio" v-model="applicant2.dec_lobbyist" value="yes">
                          Yes
                        </label>
                      </div>
                      <div class="checkbox">
                        <label>
                          <input type="radio" v-model="applicant2.dec_lobbyist" value="no">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div v-bind:class="{input_error:applicant2.dec_previous_member_error}" class="form-group">
                  <div class="row">
                    <div class="col-md-9">
                      <label>Have you previously been a member of the Liberal Party of Australia?</label>
                    </div>
                    <div class="col-md-3">
                      <div class="checkbox">
                        <label>
                          <input type="radio" v-model="applicant2.dec_previous_member" value="yes">
                          Yes
                        </label>
                      </div>
                      <div class="checkbox">
                        <label>
                          <input type="radio" v-model="applicant2.dec_previous_member" value="no">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div v-if="applicant2.dec_previous_member=='yes'"
                     v-bind:class="{input_error:applicant2.dec_suspended_error}" class="form-group">
                  <div class="row">
                    <div class="col-md-9">
                      <label>If so, have you ever been suspended or expelled from the Party?</label>
                    </div>
                    <div class="col-md-3">
                      <div class="checkbox">
                        <label>
                          <input type="radio" v-model="applicant2.dec_suspended" value="yes">
                          Yes
                        </label>
                      </div>
                      <div class="checkbox">
                        <label>
                          <input type="radio" v-model="applicant2.dec_suspended" value="no">
                          No
                        </label>
                      </div>
                    </div>
                  </div>

                </div>
                <div v-if="applicant2.dec_suspended=='yes'" class="form-group"
                     v-bind:class="{input_error:applicant2.dec_suspendedmsg_error}">
                  <div class="row">
                    <div class="col-md-12">
                      <label>If you answered yes, please provide details.</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <input id="applicant2_dec_suspendedmsg" v-model="applicant2.dec_suspendedmsg" type="text"
                             class="form-control">
                      <span v-if="applicant2.dec_suspendedmsg_error" class="error">Please provide details</span>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <!--page 6 – Donation and payment details -->
      <div class="page" data-page=6 v-if="page==6">

        <!-- hide proof of ID if telemarketer operating form-->
        <section v-if="!userIsTelemarketer">
          <div class="pd-2 dark">
            <div class="container">
              <h1>Proof of ID</h1>

              <div class="form-group" v-bind:class="{input_error:applicant1.files[1].error}">
                <label><span class="txtcap">{{ applicant1.first_name }}</span>, upload your proof of ID. This can be a
                  photo of your drivers licence, proof of age or passport.</label>
                <input type="file" v-on:change="fileSelected" accept="image/*,application/pdf" id="applicant1_identity">
                <span v-if="applicant1.files[1].error" class="error">Please select a file</span>
                <div v-if="applicant1.files[1].blob">
                  <p>
                    <img :src="applicant1.files[1].blob" width="300px" class="img">
                  </p>
                </div>

              </div>

              <div v-if="isJoint">
                <hr>
                <div class="form-group" v-bind:class="{input_error:applicant2.files[1].error}">
                  <label><span class="txtcap">{{ applicant2.first_name }}</span>, upload your proof of ID. This can be a
                    photo of your drivers licence, proof of age or passport.</label>

                  <input type="file" v-on:change="fileSelected" accept="image/*,application/pdf"
                         id="applicant2_identity">
                  <span v-if="applicant2.files[1].error" class="error">Please select a file</span>
                  <div v-if="applicant2.files[1].blob">
                    <p>
                      <img :src="this.applicant2.files[1].blob" width="300px" class="img">
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="pd-2">
            <div class="container">
              <h1>Donation Optional</h1>
              <hr>
              <label>
                <span v-if="isJoint">We</span><span v-if="!isJoint">I</span> would like to make a donation in support of
                the Liberal Party to compete against the enormous resources of the union backed Labor Party.
              </label>
              <h2>Donation Details</h2>
              <div class="form-group">
                <label>* <span v-if="isJoint">We</span><span v-if="!isJoint">I</span> would like to donate</label>
                <div class="donation-grid"><a class="btn btn-primary" v-bind:class="{selected:donationAmount(25)}"
                                              v-on:click="updateSetDonation(25)">$25</a> <a class="btn btn-primary"
                                                                                            v-bind:class="{selected:donationAmount(50)}"
                                                                                            v-on:click="updateSetDonation(50)">$50</a>
                  <a class="btn btn-primary" v-bind:class="{selected:donationAmount(100)}"
                     v-on:click="updateSetDonation(100)">$100</a> <a class="btn btn-primary"
                                                                     v-bind:class="{selected:donationAmount(500)}"
                                                                     v-on:click="updateSetDonation(500)">$500</a> <a
                      class="btn btn-primary" v-bind:class="{selected:donationAmount(1000)}"
                      v-on:click="updateSetDonation(1000)">$1000</a> <a v-if="payment.donation.set_amount"
                                                                        class="btn btn-primary"
                                                                        v-on:click="updateSetDonation(0)">No
                    Donation</a></div>
              </div>
              <transition name="fade">
                <div v-if="!payment.donation.set_amount">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group" v-bind:class="{input_error:payment.donation.donation_amount_error}">
                        <label>Insert Other Amount</label>
                        <input id="other-amount" class="form-control" v-on:change="updateProducts"
                               v-model="payment.donation.donation_amount"/>
                        <span v-if="payment.donation.donation_amount_error"
                              class="error">Please enter a valid number</span>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="checkbox">
                <label>
                  <input type="checkbox" v-model="payment.donation.monthly">
                  Please tick this box if you are interested in making a monthly donation to the Liberal Party NSW.
                </label>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="pd-2 dark">
            <div class="container">
              <h1>Payment Declaration</h1>
              <hr>
              <div class="form-group" v-bind:class="{input_error:applicant1.dec_fee_error}">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="applicant1.dec_fee">
                    <span v-if="isJoint">We</span><span v-else>I</span> acknowledge that a membership fee may only be
                    paid by the applicant or the applicant's spouse or parents (provided that the person effecting
                    payment is enrolled to vote in Federal or State elections in NSW).
                  </label>
                </div>
              </div>
              <div class="form-group" style="display:none;">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="payment.membership.renew" style="display:none;">
                    <span v-if="isJoint">We</span><span v-else>I</span> would like to renew our membership automatically
                    each year.
                  </label>
                </div>
              </div>
              <div class="form-group" v-bind:class="{input_error:applicant1.dec_year_error}">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="applicant1.dec_year">
                    <span v-if="isJoint">We</span><span v-else>I</span> acknowledge that the membership year of the
                    Liberal Party is from 1 July to 30 June. <span v-if="isJoint">We</span><span
                      v-if="!isJoint">I</span> understand this payment covers my membership from now until the end of
                    the current financial year.
                  </label>
                </div>
              </div>
              <div class="form-group">
                <div class="checkbox" v-bind:class="{input_error:applicant1.dec_constitution_error}">
                  <label>
                    <input type="checkbox" v-model="applicant1.dec_constitution">
                    <span v-if="isJoint">We</span><span v-else>I</span> agree to be bound by the Constitution of the
                    Liberal Party of Australia, NSW Division.
                  </label>
                </div>
              </div>
              <hr>
              <h2>Payment Information</h2>
              <hr>
              <div class="row">
                <div class="col-md-8">
                  <section id="pnlAmountPayble">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-3">
                          <label>Amount Payable</label>
                        </div>
                        <div class="col-md-7">
                          <label>${{ payment.membership.amount }}</label>
                        </div>
                      </div>
                    </div>
                  </section>

                  <section id="pnlPaymentMethod" v-if="userHasStaffPaymentTypes">
                    <div class="form-group">

                      <div class="row">
                        <div class="col-md-3">
                          <label>* Payment type</label>
                        </div>
                        <div class="col-md-7">
                          <select :disabled="!validate_declaration" class="form-control"
                                  v-model="payment.membership.payment_type">
                            <option value="CC">Credit card</option>
                            <option value="Cheque">Cheque</option>
                            <option value="Cash">Cash</option>
                          </select>
                        </div>

                      </div>
                    </div>
                  </section>
                  <section id="pnlCC" v-if="!payment.membership.payment_type || payment.membership.payment_type=='CC'">
                    <div class="form-group" v-bind:class="{input_error:payment.membership.card_type_error}">

                      <div class="row">
                        <div class="col-md-3">
                          <label>* CARD TYPE</label>
                        </div>
                        <div class="col-md-7">
                          <select :disabled="!validate_declaration" class="form-control"
                                  v-model="payment.membership.card_type">
                            <option :value="null">Please Select</option>
                            <option value="VISA">VISA</option>
                            <option value="MC">MASTERCARD</option>
                            <option value="AMEX">AMERICAN EXPRESS</option>
                          </select>
                          <span v-if="payment.membership.card_type_error" class="error">Please select a card type</span>

                        </div>

                      </div>
                    </div>
                    <div class="form-group" v-bind:class="{input_error:payment.membership.card_number_error}">
                      <div class="row">
                        <div class="col-md-3">
                          <label>* CARD NUMBER</label>
                        </div>
                        <div class="col-md-7">
                          <input type="text" :disabled="!validate_declaration" class="form-control" placeholder=""
                                 v-model="payment.membership.card_number">
                          <span v-if="payment.membership.card_number_error" class="error">Please enter a valid card number</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-bind:class="{input_error:payment.membership.card_holder_error}">
                      <div class="row">
                        <div class="col-md-3">
                          <label>* CARD HOLDER NAME</label>
                        </div>
                        <div class="col-md-7">
                          <input type="text" :disabled="!validate_declaration" class="form-control" placeholder=""
                                 v-model="payment.membership.card_holder">
                          <span v-if="payment.membership.card_holder_error" class="error">Please enter the card holder's name</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-3">
                          <label>*EXPIRATION DATE</label>
                        </div>
                        <div class="col-md-7">
                          <div class="row">
                            <div class="col-md-4 col-xs-6">
                              <div v-bind:class="{input_error:payment.membership.expire_month_error}">
                                <select :disabled="!validate_declaration" class="form-control col-sm-12"
                                        v-model="payment.membership.expire_month">
                                  <option :value="null">Month</option>
                                  <option value="01">01</option>
                                  <option value="02">02</option>
                                  <option value="03">03</option>
                                  <option value="04">04</option>
                                  <option value="05">05</option>
                                  <option value="06">06</option>
                                  <option value="07">07</option>
                                  <option value="08">08</option>
                                  <option value="09">09</option>
                                  <option value="10">10</option>
                                  <option value="11">11</option>
                                  <option value="12">12</option>
                                </select>
                              </div>
                            </div>

                            <div class="col-md-4 col-xs-6">
                              <div v-bind:class="{input_error:payment.membership.expire_year_error}">
                                <select :disabled="!validate_declaration" class="form-control"
                                        v-model="payment.membership.expire_year">
                                  <option :value="null">Year</option>
                                  <option v-for="year in expiry_years" :value="year">{{ year }}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Note: k-13 migration -->

                    <div class="form-group" v-if="!hideCCV"
                         v-bind:class="{input_error:payment.membership.ccv_error}">
                      <div class="row">
                        <div class="col-md-3">
                          <label>*CCV</label>
                        </div>
                        <div class="col-md-7">
                          <input type="text" :disabled="!validate_declaration" class="form-control"
                                 placeholder="Security Code" v-model="payment.membership.ccv">
                          <span v-if="payment.membership.ccv_error" class="error">Please enter the CCV</span>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section id="pnlCheque" v-if="payment.membership.payment_type=='Cheque'">
                    <div class="form-group" v-bind:class="{input_error:payment.membership.bsb_error}">
                      <div class="row">
                        <div class="col-md-3">
                          <label>* BSB</label>
                        </div>
                        <div class="col-md-7">
                          <input type="text" :disabled="!validate_declaration" id="txtBSB" class="form-control"
                                 placeholder="" v-model="payment.membership.bsb">
                          <span v-if="payment.membership.bsb_error" class="error">Please enter the BSB</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-bind:class="{input_error:payment.membership.cheque_no_error}">
                      <div class="row">
                        <div class="col-md-3">
                          <label>* Cheque number</label>
                        </div>
                        <div class="col-md-7">
                          <input type="text" :disabled="!validate_declaration" id="txtChequeNo" class="form-control"
                                 placeholder="" v-model="payment.membership.cheque_no">
                          <span v-if="payment.membership.cheque_no_error"
                                class="error">Please enter the Cheque Number</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-bind:class="{input_error:payment.membership.acc_holder_error}">
                      <div class="row">
                        <div class="col-md-3">
                          <label>* Account holder's name</label>
                        </div>
                        <div class="col-md-7">
                          <input type="text" :disabled="!validate_declaration" id="txtAccHolder" class="form-control"
                                 placeholder="" v-model="payment.membership.acc_holder">
                          <span v-if="payment.membership.acc_holder_error" class="error">Please enter the Account Holder's Name</span>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section id="pnlCash" v-if="payment.membership.payment_type=='Cash'">
                    <div class="form-group" v-bind:class="{input_error:payment.membership.cash_account_error}">
                      <div class="row">
                        <div class="col-md-3">
                          <label>* Cash account</label>
                        </div>
                        <div class="col-md-7">
                          <label id="lblCashAccount" title="" style="display:none;"></label>

                          <select id="ddlcash_account" :disabled="!validate_declaration" class="form-control"
                                  v-model="payment.membership.cash_account">
                            <option v-for="items in cash_accounts_list_data" :value="items">{{ items }}</option>
                          </select>
                          <span v-if="payment.membership.cash_account_error"
                                class="error">Please select Cash Account</span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <label>No other payment details are required</label>
                        </div>

                      </div>
                    </div>
                  </section>

                  <div class="form-group">
                    <button type="button" class="btn btn-primary next"
                            :disabled="!validate_declaration || captcha_verifying" v-on:click="validate"><i
                        v-if="captcha_verifying" class="fa fa-spinner fa-spin"></i> Pay Now
                    </button>

                  </div>
                  <div class="form-group">
                    <ul v-if="payment.result.errors.length > 0" class="alert-danger">
                      <li v-for="item in payment.result.errors">
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- page 7 – Confirmation -->
      <div class="page" data-page=7 v-if="page==7">
        <section>
          <div class="pd-2 dark">
            <div class="container">
              <h1>Thank You</h1>
              <hr>
              <p> Thank you for applying to join the NSW Liberal Party. You will shortly receive a confirmation email
                with details of how you can track the progress of your application, along with your receipt for payment
                of your membership fee. </p>
              <p> If you have any questions regarding your application, please contact our Membership Team by email at
                <a href="mailto:membership@nsw.liberal.org.au">membership@nsw.liberal.org.au</a>, or by phone on <a
                    href="tel:(02) 8356 0300">(02) 8356 0300</a>. </p>
              <div>
                <h3>Transaction Reference Number: <span
                    class="highlight">{{ payment.result.valid.reference_number }}</span></h3>
                <h3>Amount Paid: <span class="highlight">${{ payment.result.valid.amount_paid }}</span></h3>
              </div>
            </div>
          </div>
        </section>
      </div>

    </div>
    <section>
      <div class="pd-2 progress-container">
        <div class="container">
          <h3>Your Progress</h3>
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <div class="progress-outer">
                <div class="progress-inner" v-bind:style="progress"></div>
              </div>
            </div>
          </div>
          <div class="next-but">
            <span v-if="page>1 && page<6"> <a class="btn btn-primary" v-on:click="validateback"><i
                class="fa fa-chevron-left"></i> Back</a> </span>
            <span v-if="page<6"><a class="btn btn-primary next" v-on:click="validate">Next <i
                class="fa fa-chevron-right"></i></a> </span>

          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import axios from "axios";

// import {mapGetters} from "vuex";
import {mapActions, mapGetters} from "vuex"

var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
var testMobno = /^04\d{8}$/;


export default {
  mounted: function mounted() {
    this.setUserFromCookie()
    this.getPrefixes();
    this.getStreetTypes();
    this.captchaLoad();
    this.loading = false;
  },

  created: function created() {
    //loaditems

    this.products = [{
      product_description: null,
      product_code: "PATRON",
      price: null,
      can_joint: false,
      age_limit: 200,
      can_show: true,
      is_concession: false
    }, {
      product_description: null,
      product_code: "PLAT",
      price: null,
      can_joint: true,
      age_limit: 200,
      can_show: true,
      is_concession: false
    }, {
      product_description: null,
      product_code: "GOLD",
      price: null,
      can_joint: true,
      age_limit: 200,
      can_show: true,
      is_concession: false
    }, {
      product_description: null,
      product_code: "BASIC",
      price: null,
      can_joint: true,
      age_limit: 200,
      can_show: true,
      is_concession: false
    }, {
      product_description: null,
      product_code: "CONCES",
      price: null,
      can_joint: true,
      age_limit: 200,
      can_show: true,
      is_concession: true
    }, {
      product_description: null,
      product_code: "YLB",
      price: null,
      can_joint: false,
      age_limit: 30,
      can_show: false,
      is_concession: false

    }, {
      product_description: null,
      product_code: "JNR",
      price: null,
      can_joint: false,
      age_limit: 18,
      can_show: false,
      is_concession: false
    }];
    var y = parseInt(moment().format('YY'));
    var y2 = y + 10;
    for (var i = y; i < y2; i++) {
      this.expiry_years.push(i);
    }

    for (var i = 1; i <= 31; i++) {
      this.applicantDob_days.push(i);
    }

    for (var i = 1; i <= 12; i++) {
      this.applicantDob_months.push(i);
    }

    var y3 = parseInt(moment().format('YYYY'));
    var y4 = y3 - 18;
    for (var i = 1900; i <= y4; i++) {
      this.applicantDob_years.push(i);
    }
  },
  updated: function updated() {
    if (this.applicant2.address.same_as) {
      this.sameAsAbove();
    }
    if (this.applicant1.postaladdress.same_as) {
      this.sameAsElect_Applicant1();
    }
    if (this.applicant2.postaladdress.same_as) {
      this.sameAsElect_Applicant2();
    }

    if (!this.applicant1.dec_fee || !this.applicant1.dec_year || !this.applicant1.dec_constitution) {
      this.validate_declaration = false;
    } else {
      this.validate_declaration = true;
    }

    if (this.validating) {
      if (this.error) {
        this.scrollToError()
      }
      this.validating = false;
    }
  },
  data() {
    return {
      birth_dates: {
        disabledDates: {
          from: new Date()
        },
        cls: "form-control",
        icon: "fa fa-calendar"
      },
      captcha_verifying: false,
      captchaToken: null,
      validating: false,
      validate_attempt: 0,
      loggeduser: "",
      validate_member: false,
      validate_declaration: false,
      is_staff_user_in_role: false,
      // hideCCV: false,
      cash_accounts_list_data: ["Cash"],
      is_back: false,
      captcha_error: false,
      loading: false,
      error: false,
      loading_msg: "Loading Application",
      page: 0,
      expiry_years: [],
      total_pages: 7,
      progress: null,
      prefixes: null,
      products: null,
      street_types: null,
      isSingle: true,
      isJoint: false,
      applicant1Day: null,
      applicant1Month: null,
      applicant1Year: null,
      applicant2Day: null,
      applicant2Month: null,
      applicant2Year: null,
      applicantDob_days: [],
      applicantDob_months: [],
      applicantDob_years: [],

      applicant1: {
        years: null,
        id: 0,
        feedbackid: 0,
        is_concession: false,
        picked: null,
        picked_error: false,
        prefix: null,
        prefix_error: false,
        first_name: "",
        first_name_error: false,
        middle_name: null,
        last_name: "",
        last_name_error: false,
        date_of_birth: null,
        date_of_birth_error: false,
        email: null,
        email_error: false,
        mobile_phone: null,
        mobile_phone_error: false,
        home_phone: null,
        home_phone_error: false,
        address: {
          street_number: null,
          street_number_error: false,
          street_name: null,
          street_name_error: false,
          street_type: null,
          street_type_error: false,
          suburb: null,
          suburb_error: false,
          state: null,
          state_error: false,
          post_code: null,
          post_code_error: false,
          validate_error: false,
          validate_errormob: false,
          validate_errorelectoral2: false,
          validate_duplicate: false,
          electorate: {
            valid: null,
            electorate_code: null,
            id: 0
          }
        },
        postaladdress: {
          use_pobox: false,
          address1: null,
          address1_error: false,
          street_number: null,
          street_number_error: false,
          street_name: null,
          street_name_error: false,
          street_type: null,
          street_type_error: false,
          suburb: null,
          suburb_error: false,
          state: null,
          state_error: false,
          post_code: null,
          post_code_error: false,
          validate_error: false,
          validate_errormob: false,
          validate_errorelectoral2: false,
          validate_duplicate: false,
          same_as: null,
          electorate: {
            valid: null,
            electorate_code: null,
            id: 0
          }
        },
        dec_1: null,
        dec_1_error: false,
        dec_2: null,
        dec_2_error: false,
        dec_party: null,
        dec_party_error: false,
        dec_candidate: null,
        dec_candidate_error: false,
        dec_prohibited_funding: "",
        dec_prohibited_funding_error: false,
        dec_lobbyist: "",
        dec_lobbyist_error: false,
        dec_previous_member: "",
        dec_previous_member_error: false,
        dec_suspended: "",
        dec_suspended_error: false,
        dec_suspendedmsg: "",
        dec_suspendedmsg_error: false,
        dec_fee: null,
        dec_fee_error: false,
        dec_year: null,
        dec_year_error: false,
        dec_constitution: null,
        dec_constitution_error: false,
        branch_code: null,
        branch_code_error: false,
        branch_type: null,
        branch_type_error: false,
        branches: null,

        files: [{
          type: "consession",
          blob: "",
          error: false
        }, {
          type: "identity",
          blob: "",
          error: false
        }],
        products: []
      },
      is_young_liberal: false,
      is_not_young_liberal: true,
      is_young_liberal_eligible: false,
      applicant2: {
        years: null,
        id: 0,
        feedbackid: 0,
        is_concession: false,
        picked: null,
        picked_error: false,
        prefix: null,
        prefix_error: false,
        first_name: "",
        first_name_error: false,
        middle_name: null,
        last_name: "",
        last_name_error: false,
        date_of_birth: null,
        date_of_birth_error: false,
        email: null,
        email_error: false,
        mobile_phone: null,
        mobile_phone_error: false,
        home_phone: null,
        home_phone_error: false,
        address: {
          street_number: null,
          street_number_error: false,
          street_name: null,
          street_name_error: false,
          street_type: null,
          street_type_error: false,
          suburb: null,
          suburb_error: false,
          state: null,
          state_error: false,
          post_code: null,
          post_code_error: false,
          validate_error: false,
          validate_errormob: false,
          validate_errorelectoral2: false,
          validate_duplicate: false,
          same_as: null,
          electorate: {
            valid: null,
            electorate_code: null,
            id: null
          }
        },
        postaladdress: {
          use_pobox: false,
          address1: null,
          address1_error: false,
          street_number: null,
          street_number_error: false,
          street_name: null,
          street_name_error: false,
          street_type: null,
          street_type_error: false,
          suburb: null,
          suburb_error: false,
          state: null,
          state_error: false,
          post_code: null,
          post_code_error: false,
          validate_error: false,
          validate_errormob: false,
          validate_errorelectoral2: false,
          validate_duplicate: false,
          same_as: null,
          electorate: {
            valid: null,
            electorate_code: null,
            id: null
          }
        },
        dec_1: null,
        dec_1_error: false,
        dec_2: null,
        dec_2_error: false,
        dec_party: null,
        dec_party_error: false,
        dec_candidate: null,
        dec_candidate_error: false,
        dec_prohibited_funding: "",
        dec_prohibited_funding_error: false,
        dec_lobbyist: "",
        dec_lobbyist_error: false,
        dec_previous_member: "",
        dec_previous_member_error: false,
        dec_suspended: "",
        dec_suspended_error: false,
        dec_suspendedmsg: "",
        dec_suspendedmsg_error: false,
        dec_fee: null,
        dec_fee_error: false,
        dec_year: null,
        dec_year_error: false,
        dec_constitution: null,
        dec_constitution_error: false,
        branch_code: null,
        branch_code_error: false,
        branch_type: null,
        branch_type_error: false,
        branches: null,
        files: [{
          type: "consession",
          blob: "",
          error: false
        }, {
          type: "identity",
          blob: "",
          error: false
        }],
        products: []
      },
      payment: {
        donation: {
          monthly: false,
          donation_amount: null,
          donation_amount_error: false,
          set_amount: false,
          error: false
        },
        membership: {
          renew: false,
          card_type: null,
          card_type_error: false,
          card_number: null,
          card_number_error: false,
          card_holder: null,
          card_holder_error: false,
          expire_month: null,
          expire_month_error: false,
          expire_year: null,
          expire_year_error: false,
          ccv: null,
          ccv_error: false,
          amount: 0,
          payment_type: 'CC',
          bsb_error: false,
          bsb: null,
          cheque_no_error: false,
          cheque_no: null,
          acc_holder_error: false,
          acc_holder: null,
          cash_account_error: false,
          cash_account: 'CASH'
        },
        result: {
          result: null,
          valid: null,
          errors: []
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'authorizationHeadersStored',
      'userIsStaff',
      'userHasStaffPaymentTypes',
      'userIsTelemarketer'
    ]),
    hideCCV() {
      return this.userHasStaffPaymentTypes || this.userIsTelemarketer
    },
  },
  watch: {
    applicant1Day: function applicant1Day(val, oldVal) {

      var app1Dob = this.applicant1Year + "/" + this.applicant1Month + "/" + this.applicant1Day;
      // console.log("Before moment format app1Dob:" + app1Dob)
      app1Dob = moment(app1Dob).format('YYYY/MM/DD');
      // console.log("After moment format app1Dob:"+app1Dob);
      var date = moment(app1Dob, 'YYYY/MM/DD', true);

      if (date.isValid()) {
        // console.log("yay");
        this.applicant1.date_of_birth_error = false;
        this.updateApp1Dob(app1Dob);
      } else {
        this.applicant1.date_of_birth_error = true;
        // console.log("nay");
      }
    },
    applicant1Month: function applicant1Month(val, oldVal) {

      var app1Dob = this.applicant1Year + "/" + this.applicant1Month + "/" + this.applicant1Day;
      app1Dob = moment(app1Dob).format('YYYY/MM/DD');
      //console.log("app1Dob:" + app1Dob);
      var date = moment(app1Dob, 'YYYY/MM/DD', true);

      if (date.isValid()) {
        // console.log("yay");
        this.applicant1.date_of_birth_error = false;
        this.updateApp1Dob(app1Dob);
      } else {
        this.applicant1.date_of_birth_error = true;
        // console.log("nay");
      }
    },
    applicant1Year: function applicant1Year(val, oldVal) {
      var app1Dob = this.applicant1Year + "/" + this.applicant1Month + "/" + this.applicant1Day;
      app1Dob = moment(app1Dob).format('YYYY/MM/DD');
      // console.log("app1Dob:" + app1Dob);
      var date = moment(app1Dob, 'YYYY/MM/DD', true);

      if (date.isValid()) {
        this.applicant1.date_of_birth_error = false;
        // console.log("yay");
        this.updateApp1Dob(app1Dob);
      } else {
        this.applicant1.date_of_birth_error = true;
        // console.log("nay");
      }
    },

    applicant2Day: function applicant2Day(val, oldVal) {
      var app2Dob = this.applicant2Year + "/" + this.applicant2Month + "/" + this.applicant2Day;
      app2Dob = moment(app2Dob).format('YYYY/MM/DD');
      // console.log("app2Dob:" + app2Dob);
      var date = moment(app2Dob, 'YYYY/MM/DD', true);

      if (date.isValid()) {
        // console.log("yay");
        this.applicant2.date_of_birth_error = false;
        this.updateApp2Dob(app2Dob);
      } else {
        this.applicant2.date_of_birth_error = true;
        // console.log("nay");
      }
    },
    applicant2Month: function applicant2Month(val, oldVal) {
      var app2Dob = this.applicant2Year + "/" + this.applicant2Month + "/" + this.applicant2Day;
      app2Dob = moment(app2Dob).format('YYYY/MM/DD');
      // console.log("app2Dob:" + app2Dob);
      var date = moment(app2Dob, 'YYYY/MM/DD', true);

      if (date.isValid()) {
        // console.log("yay");
        this.applicant2.date_of_birth_error = false;
        this.updateApp2Dob(app2Dob);
      } else {
        this.applicant2.date_of_birth_error = true;
        // console.log("nay");
      }
    },
    applicant2Year: function applicant2Year(val, oldVal) {
      var app2Dob = this.applicant2Year + "/" + this.applicant2Month + "/" + this.applicant2Day;
      app2Dob = moment(app2Dob).format('YYYY/MM/DD');
      // console.log("app2Dob:" + app2Dob);
      var date = moment(app2Dob, 'YYYY/MM/DD', true);

      if (date.isValid()) {
        // console.log("yay");
        this.applicant2.date_of_birth_error = false;
        this.updateApp2Dob(app2Dob);
      } else {
        this.applicant2.date_of_birth_error = true;
        // console.log("nay");
      }
    },

    prefixes: function prefixes(val, oldVal) {
      this.checkLoaded();
    },
    street_types: function street_types(val, oldVal) {
      this.checkLoaded();
    },
    payment: {
      handler: function handler(val, oldVal) {
        if (val.result.valid) {
          if (val.result.valid.membership_number) {
            this.changePage(7);
          }
        }
      },

      deep: true
    },
    products: {
      handler: function handler(val, oldVal) {

        if (this.page == 2) {
          var loaded = true;
          for (var i = 0; i < val.length; i++) {
            if (val[i].price == null) {
              loaded = false;
            }
          }
          if (loaded) {
            //this.loading = false;
            //this.changePage(3);
          }
        }
      },

      deep: true
    },
    applicant1: {
      handler: function handler(val, oldVal) {
        if (this.page == 1 && !this.is_back) {
          if (val.address.electorate.valid && !Array.isArray(this.applicant1.branches)) {
            this.getBranch(val);
          } else {
            this.checkAddressesValidated();
          }
        }
      },

      deep: true
    },
    applicant2: {
      handler: function handler(val, oldVal) {
        if (this.page == 1 && !this.is_back) {
          if (val.address.electorate.valid && !Array.isArray(this.applicant2.branches)) {
            this.getBranch(val);
          } else {
            this.checkAddressesValidated();
          }
        }
      },

      deep: true
    }
  },
  methods: {
    ...mapActions('auth', ['setUserFromCookie']),
    captchaLoad: function loadRecaptcha() {
      if (typeof grecaptcha === "undefined") {
        var script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=6LfkxZcUAAAAABnsb1t0UcrxhDfzf4urHtT881Tk";
        //script.onload = this.captchaWait;
        document.head.appendChild(script);
      }
    },
    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      this.captchaToken = recaptchaToken;
      this.captcha_verifying = false;
      //payment
      var member_type = "IND";
      if (this.isJoint) {
        member_type = "JNT";
      }
      var address1_street_type = this.applicant1.address.street_type;
      if (address1_street_type == "None") {
        address1_street_type = "";
      }
      var postaladdress1_street_type = this.applicant1.postaladdress.street_type;
      if (postaladdress1_street_type == "None") {
        postaladdress1_street_type = "";
      }


      /* k-13 */
      let applicant1Email = this.applicant1.email,
          applicant1Mobile = this.applicant1.mobile_phone,
          applicant2Email = this.applicant2.email,
          applicant2Mobile = this.applicant2.mobile_phone


      if (this.userIsStaff) {
        if (!applicant1Email) applicant1Email = ''
        if (!applicant1Mobile) applicant1Mobile = ''
        if (!applicant2Email) applicant2Email = ''
        if (!applicant2Mobile) applicant2Mobile = ''
      }


      var details = {
        member_type_code: member_type,
        captcha_token: this.captchaToken,
        applicant1: {
          prefix: this.applicant1.prefix,
          id: this.applicant1.id,
          feedbackid: this.applicant1.feedbackid,
          first_name: this.applicant1.first_name,
          middle_name: this.applicant1.middle_name,
          last_name: this.applicant1.last_name,
          date_of_birth: this.applicant1.date_of_birth,
          email: applicant1Email,
          mobile_phone: applicant1Mobile,
          home_phone: this.applicant1.home_phone,
          dec_prohibited_funding: this.applicant1.dec_prohibited_funding,
          dec_lobbyist: this.applicant1.dec_lobbyist,
          dec_previous_member: this.applicant1.dec_previous_member,
          dec_suspended: this.applicant1.dec_suspended,
          dec_suspendedmsg: this.applicant1.dec_suspendedmsg,
          address: {
            street_number: this.applicant1.address.street_number,
            street_name: this.applicant1.address.street_name,
            street_type: address1_street_type,
            suburb: this.applicant1.address.suburb,
            state: this.applicant1.address.state,
            post_code: this.applicant1.address.post_code

          },
          postaladdress: {
            address1: this.applicant1.postaladdress.address1,
            street_number: this.applicant1.postaladdress.street_number,
            street_name: this.applicant1.postaladdress.street_name,
            street_type: postaladdress1_street_type,
            suburb: this.applicant1.postaladdress.suburb,
            state: this.applicant1.postaladdress.state,
            post_code: this.applicant1.postaladdress.post_code

          },
          branch_code: this.applicant1.branch_code,
          files: [{
            type: "consession",
            blob: this.applicant1.files[0].blob
          }, {
            type: "identity",
            blob: this.applicant1.files[1].blob
          }],
          products: [],
          young_liberal: this.is_young_liberal
        },
        payment: {
          donation: {
            monthly: this.payment.donation.monthly,
            donation_amount: this.payment.donation.donation_amount
          },
          membership: {
            renew: this.payment.membership.renew,
            card_type: this.payment.membership.card_type,
            card_number: this.payment.membership.card_number,
            card_holder: this.payment.membership.card_holder,
            expire_month: this.payment.membership.expire_month,
            expire_year: this.payment.membership.expire_year,
            ccv: this.payment.membership.ccv,
            amount: this.payment.membership.amount,
            payment_type: this.payment.membership.payment_type,
            bsb: this.payment.membership.bsb,
            cheque_no: this.payment.membership.cheque_no,
            acc_holder: this.payment.membership.acc_holder,
            cash_account: this.payment.membership.cash_account,
            // note: k-13 migration
            // staff_user_in_role: this.is_staff_user_in_role
            staff_user_in_role: this.userIsStaff || this.userIsTelemarketer
          }
        }
      };
      for (var i = 0; i < this.applicant1.products.length; i++) {
        details.applicant1.products.push(this.applicant1.products[i]);
      }

      if (this.isJoint) {
        var address2_street_type = this.applicant2.address.street_type;
        if (address2_street_type == "None") {
          address2_street_type = "";
        }
        var postaladdress2_street_type = this.applicant2.postaladdress.street_type;
        if (postaladdress2_street_type == "None") {
          postaladdress2_street_type = "";
        }
        details.applicant2 = {
          prefix: this.applicant2.prefix,
          id: this.applicant2.id,
          feedbackid: this.applicant2.feedbackid,
          first_name: this.applicant2.first_name,
          middle_name: this.applicant2.middle_name,
          last_name: this.applicant2.last_name,
          date_of_birth: this.applicant2.date_of_birth,
          email: applicant2Email,
          mobile_phone: applicant2Mobile,
          home_phone: this.applicant2.home_phone,
          dec_prohibited_funding: this.applicant2.dec_prohibited_funding,
          dec_lobbyist: this.applicant2.dec_lobbyist,
          dec_previous_member: this.applicant2.dec_previous_member,
          dec_suspended: this.applicant2.dec_suspended,
          dec_suspendedmsg: this.applicant2.dec_suspendedmsg,
          address: {
            street_number: this.applicant2.address.street_number,
            street_name: this.applicant2.address.street_name,
            street_type: address2_street_type,
            suburb: this.applicant2.address.suburb,
            state: this.applicant2.address.state,
            post_code: this.applicant2.address.post_code
          },
          postaladdress: {
            address1: this.applicant2.postaladdress.address1,
            street_number: this.applicant2.postaladdress.street_number,
            street_name: this.applicant2.postaladdress.street_name,
            street_type: postaladdress2_street_type,
            suburb: this.applicant2.postaladdress.suburb,
            state: this.applicant2.postaladdress.state,
            post_code: this.applicant2.postaladdress.post_code

          },
          branch_code: this.applicant2.branch_code,
          files: [{
            type: "consession",
            blob: this.applicant2.files[0].blob
          }, {
            type: "identity",
            blob: this.applicant2.files[1].blob
          }],
          products: [],
          young_liberal: this.is_young_liberal
        };
        for (var i = 0; i < this.applicant2.products.length; i++) {
          details.applicant2.products.push(this.applicant2.products[i]);
        }
      }

      //this.$refs.recaptcha.reset();
      this.join(details);
    },
    //onCaptchaExpired: function onCaptchaExpired() {
    //    this.$refs.recaptcha.reset();
    //},

    getProducts: function getProducts() {
      var _this = this;

      this.loading = true;
      this.loading_msg = "Loading Products";

      const joinType = this.isJoint ? "JNT" : "IND"

      for (var i = 0; i < this.products.length; i++) {
        axios.get("/api/join/price?joinType=" + joinType + "&productCode=" + this.products[i].product_code).then(function (response) {
          for (var x = 0; x < _this.products.length; x++) {
            if (_this.products[x].product_code == response.data[0].product_code) {
              _this.products[x].product_description = response.data[0].product_description;
              _this.products[x].price = response.data[0].price;
            }
          }
          _this.loading = false;
        }, function (error) {
          console.log(error);
          _this.loading = false;
        });
      }
    },
    join: function join(application) {
      var _this2 = this;

      this.loading = true;
      this.loading_msg = "Sending Application ";

      // debug logs


      //  k-13 migration - set URL and auth headers based on staff role from validated cookie
      const url = this.hideCCV ? '/api/join/staffjoin' : '/api/join/join'
      const headers = this.hideCCV ? this.authorizationHeadersStored : {}


      axios.post(url, {
        member_type_code: application.member_type_code,
        captcha_token: application.captcha_token,
        applicant1: application.applicant1,
        applicant2: application.applicant2,
        payment: application.payment,
      }, {headers})
          .then(function (response) {
            _this2.payment.result = response.data;
            _this2.loading = false;
            //_this2.$refs.recaptcha.reset();
          }, function (error) {
            console.log(error);
            _this2.loading = false;
          });
    },
    getBranch: function getBranch(applicant) {
      var _this3 = this;

      this.loading = true;
      this.loading_msg = "Loading Branches";
      var ApplicantType = "standard";
      if (this.is_young_liberal) ApplicantType = "young";
      axios.get("/api/join/electorate?electorateCode=" + applicant.address.electorate.electorate_code + "&applicantType=" + ApplicantType).then(function (response) {
        applicant.branches = response.data;
        _this3.loading = false;
      }, function (error) {
        console.log(error);
        _this3.loading = false;
      });
    },
    getPrefixes: function getPrefixes() {
      var _this4 = this;

      this.loading = true;
      this.loading_msg = "Loading Prefixes";
      axios.get("/api/join/prefixes").then(function (response) {
        _this4.prefixes = response.data;
        _this4.loading = false;
      }, function (error) {
        console.log(error);
        _this4.loading = false;
      });
    },
    getStreetTypes: function getStreetTypes() {
      var _this5 = this;

      this.loading = true;
      this.loading_msg = "Loading Street Types";
      axios.get("/api/join/street_types").then(function (response) {
        _this5.street_types = response.data;
        _this5.loading = false;
      }, function (error) {
        console.log(error);
        _this5.loading = false;
      });
    },
    getElectorateCode: function getElectorateCode(applicant) {

      // console.log(applicant)
      var _this6 = this;

      this.loading = true;
      this.loading_msg = "Validating Address";

      var address_street_type = applicant.address.street_type;
      if (address_street_type == "None") {
        address_street_type = "";
      }
      var postaladdress_street_type = applicant.postaladdress.street_type;
      if (postaladdress_street_type == "None") {
        postaladdress_street_type = "";
      }

      /* note: setup to allow for empty email / mobile for staff users */
      let applicantEmail = applicant.email
      let applicantMobile = applicant.mobile_phone


      // allow empty email / mobile for staff users
      if (this.userIsStaff) {
        if (!applicantEmail) applicantEmail = ''
        if (!applicantMobile) applicantMobile = ''
      }

      axios.post('/api/join/validate_address', {
        first_name: applicant.first_name,
        last_name: applicant.last_name,
        street_number: applicant.address.street_number,
        street_name: applicant.address.street_name,
        post_code: applicant.address.post_code,
        suburb: applicant.address.suburb,
        mobile_phone: applicantMobile,
        email: applicantEmail,
        // date_of_birth: applicant.date_of_birth.format('dd/MM/yyyy'),
        date_of_birth: moment(applicant.date_of_birth).format('DD/MM/YYYY'),
        applicant: {
          prefix: applicant.prefix,
          id: applicant.id,
          feedbackid: applicant.feedbackid,
          first_name: applicant.first_name,
          middle_name: applicant.middle_name,
          last_name: applicant.last_name,
          date_of_birth: applicant.date_of_birth,
          email: applicantEmail,
          mobile_phone: applicantMobile,
          home_phone: applicant.home_phone,
          dec_prohibited_funding: applicant.dec_prohibited_funding,
          dec_lobbyist: applicant.dec_lobbyist,
          dec_previous_member: applicant.dec_previous_member,
          dec_suspended: applicant.dec_suspended,
          dec_suspendedmsg: applicant.dec_suspendedmsg,
          address: {
            street_number: applicant.address.street_number,
            street_name: applicant.address.street_name,
            street_type: address_street_type,
            suburb: applicant.address.suburb,
            state: applicant.address.state,
            post_code: applicant.address.post_code

          },
          postaladdress: {
            address1: applicant.postaladdress.address1,
            street_number: applicant.postaladdress.street_number,
            street_name: applicant.postaladdress.street_name,
            street_type: postaladdress_street_type,
            suburb: applicant.postaladdress.suburb,
            state: applicant.postaladdress.state,
            post_code: applicant.postaladdress.post_code

          }
        }

      }).then(function (response) {
        applicant.address.electorate = response.data;

        if (response.data.valid) {
          applicant.feedbackid = response.data.feedbackid;
          //reset
          applicant.address.validate_error = false;
          applicant.address.validate_errorelectoral2 = false;
          applicant.address.validate_errormob = false;
          _this6.validate_member = false;

          if (response.data.id == '-1') {
            //duplicate found then show message

            applicant.address.validate_duplicate = true;
            response.data.valid = false;
          } else if (response.data.id == '-2') {
            //get an error when save member profile

            _this6.validate_member = true;
            response.data.valid = false;
          } else {
            applicant.id = response.data.id; //found existing record.
            applicant.address.validate_duplicate = false;
          }
          //Staff Processing
          if (response.data.cash_accounts_list != null && response.data.cash_accounts_list.length > 0) {

            _this6.cash_accounts_list_data = response.data.cash_accounts_list;
          }

          /*
                    note: k-13 will always return false
                    if (response.data.hide_ccv) _this6.hideCCV = true;
                    if (response.data.staff_user_in_role) _this6.is_staff_user_in_role = true;
                    */
        } else {
          if (_this6.validate_attempt > 1) {
            applicant.address.validate_error = false;
            //second time show other message
            applicant.address.validate_errorelectoral2 = true;
            _this6.error = true;
            _this6.loading = false;
            _this6.scrollAddressError();
          } else {
            applicant.address.validate_error = true;
            _this6.error = true;
            _this6.loading = false;
            _this6.scrollAddressError();
            _this6.validate_attempt = _this6.validate_attempt + 1;
          }
        }
        _this6.loading = false;
      }, function (error) {
        console.log(error);
        _this6.loading = false;
      });


    },
    scrollAddressError: function scrollAddressError() {
      setTimeout(function () {
        $('html, body').scrollTop($('#address1-validate').offset().top);
      }, 1000)
      //$('html, body').animate({
      //    scrollTop: $('#address1-validate').offset().top
      //}, 300);
    },
    checkAddressesValidated: function checkAddressesValidated() {

      let proceed = Array.isArray(this.applicant1.branches)
      if (proceed && this.isJoint) {
        proceed = Array.isArray(this.applicant2.branches)
      }
      if (proceed) {
        this.getProducts();
        this.changePage(2);
      }

      /*
      if (this.isJoint) {
        if (Array.isArray(this.applicant1.branches) && Array.isArray(this.applicant2.branches)) {

          this.getProducts();
          this.changePage(2);
        }
      } else {
        if (Array.isArray(this.applicant1.branches)) {

          this.getProducts();
          this.changePage(2);
        }
      }
      */
    },
    checkLoaded: function checkLoaded() {
      if (this.prefixes && this.street_types) {
        this.changePage(1);
      }
    },
    donationAmount: function donationAmount(amount) {
      if (this.payment.donation.donation_amount == parseFloat(amount)) {
        return true;
      } else {
        return false;
      }
    },
    single_applicant: function single_applicant(event) {
      this.isSingle = true;
      this.isJoint = false;
      if (this.applicant1.years !== null && this.applicant1.years < 31) {
        this.is_young_liberal_eligible = true;
      }

      this.products[5].can_show = true;
    },
    joint_applicant: function joint_applicant(event) {
      this.isJoint = true;
      this.isSingle = false;
      this.is_young_liberal_eligible = false;
      this.is_young_liberal = false;
      this.is_not_young_liberal = true;
      this.products[5].can_show = false;
    },
    updateApp1Dob: function updateApp1Dob(date) {

      this.applicant1.date_of_birth = moment(date).format('YYYY/MM/DD');
      this.applicant1.years = moment().diff(date, 'years', false);

      if (this.applicant1.years !== null && this.applicant1.years < 31) {
        this.is_young_liberal_eligible = true;
      } else {
        this.is_young_liberal_eligible = false;
        this.is_young_liberal = false;
      }
    },
    updateApp2Dob: function updateApp2Dob(date) {
      this.applicant2.date_of_birth = moment(date).format('YYYY/MM/DD');
    },
    add_young_liberal: function add_young_liberal(event) {
      this.is_young_liberal = true;
      this.is_not_young_liberal = false;
      this.products[4].can_show = false;
      this.products[5].can_show = true;
      this.products[3].can_show = false;
    },
    remove_young_liberal: function remove_young_liberal(event) {
      this.is_young_liberal = false;
      this.is_not_young_liberal = true;
      this.products[4].can_show = true;
      this.products[5].can_show = false;
      this.products[3].can_show = true;
    },
    validateback: function validateback() {
      if (this.page > 1) {
        this.page = this.page - 1;
        this.changePage(this.page);
        this.is_back = true;
      }
    },
    validate: function validate() {
      this.validating = true;
      this.is_back = false;
      if (this.page == 6) {
        if (this.captcha_verifying) {
          return false;
        }
        this.error = false;

        // skip file validation for telemarketers

        // if (!this.applicant1.files[1].blob) { note: delete comment
        if (!this.applicant1.files[1].blob && !this.userIsTelemarketer) {
          this.applicant1.files[1].error = true;
          this.error = true;
        } else {
          this.applicant1.files[1].error = false;
        }

        if (this.isJoint) {
          if (!this.applicant2.files[1].blob && !this.userIsTelemarketer) {
            this.applicant2.files[1].error = true;
            this.error = true;
          } else {
            this.applicant2.files[1].error = false;
          }
        }

        if (!this.applicant1.dec_fee || !this.applicant1.dec_year || !this.applicant1.dec_constitution) {
          this.validate_declaration = false;
        } else {
          this.validate_declaration = true;
        }

        if (!this.applicant1.dec_fee) {
          this.applicant1.dec_fee_error = true;
          this.error = true;
        } else {
          this.applicant1.dec_fee_error = false;
        }

        if (!this.applicant1.dec_year) {
          this.applicant1.dec_year_error = true;
          this.error = true;
        } else {
          this.applicant1.dec_year_error = false;
        }

        if (!this.applicant1.dec_constitution) {
          this.applicant1.dec_constitution_error = true;
          this.error = true;
        } else {
          this.applicant1.dec_constitution_error = false;
        }

        if (this.payment.donation.donation_amount && isNaN(this.payment.donation.donation_amount)) {
          this.payment.donation.donation_amount = 0;
          this.payment.donation.donation_amount_error = true;
          this.error = true;
        } else {
          this.payment.donation.donation_amount_error = false;
        }

        if (!this.payment.membership.payment_type || this.payment.membership.payment_type == "CC") {
          this.payment.membership.payment_type = "CC";

          if (!this.payment.membership.card_type) {
            this.payment.membership.card_type_error = true;
            this.error = true;
          } else {
            this.payment.membership.card_type_error = false;
          }

          if (!this.payment.membership.card_number) {
            this.payment.membership.card_number_error = true;
            this.error = true;
          } else {
            this.payment.membership.card_number_error = false;
          }

          if (!this.payment.membership.card_holder) {
            this.payment.membership.card_holder_error = true;
            this.error = true;
          } else {
            this.payment.membership.card_holder_error = false;
          }

          if (!this.payment.membership.expire_month) {
            this.payment.membership.expire_month_error = true;
            this.error = true;
          } else {
            this.payment.membership.expire_month_error = false;
          }

          if (!this.payment.membership.expire_year) {
            this.payment.membership.expire_year_error = true;
            this.error = true;
          } else {
            this.payment.membership.expire_year_error = false;
          }

          // note: only apply this verification if not staff member (k-13 migration)
          if (!this.hideCCV && !this.payment.membership.ccv) {
            this.payment.membership.ccv_error = true;
            this.error = true;
          } else {
            this.payment.membership.ccv_error = false;
          }
        } else if (this.payment.membership.payment_type == "Cheque") {
          if (!this.payment.membership.bsb) {
            this.payment.membership.bsb_error = true;
            this.error = true;
          } else {
            this.payment.membership.bsb_error = false;
          }

          if (!this.payment.membership.acc_holder) {
            this.payment.membership.acc_holder_error = true;
            this.error = true;
          } else {
            this.payment.membership.acc_holder_error = false;
          }

          if (!this.payment.membership.cheque_no) {
            this.payment.membership.cheque_no_error = true;
            this.error = true;
          } else {
            this.payment.membership.cheque_no_error = false;
          }
        } else if (this.payment.membership.payment_type == "Cash") {
          if (!this.payment.membership.cash_account) {
            this.payment.membership.cash_account_error = true;
            this.error = true;
          } else {
            this.payment.membership.cash_account_error = false;
          }
        }
        if (!this.error) {
          //this.$refs.recaptcha.execute();
          var this_captcha = this;
          this.captcha_verifying = true;
          grecaptcha.ready(function () {
            grecaptcha.execute('6LfkxZcUAAAAABnsb1t0UcrxhDfzf4urHtT881Tk', {action: 'submit'}).then(function (token) {
              this_captcha.onCaptchaVerified(token);
            });
          });
        }
      }
      if (this.page == 5) {
        this.error = false;
        if (!this.applicant1.dec_prohibited_funding) {
          this.applicant1.dec_prohibited_funding_error = true;
          this.error = true;
        } else {
          this.applicant1.dec_prohibited_funding_error = false;
        }

        if (!this.applicant1.dec_lobbyist) {
          this.applicant1.dec_lobbyist_error = true;
          this.error = true;
        } else {
          this.applicant1.dec_lobbyist_error = false;
        }

        if (!this.applicant1.dec_previous_member) {
          this.applicant1.dec_previous_member_error = true;
          this.error = true;
        } else {
          this.applicant1.dec_previous_member_error = false;
        }

        if (this.applicant1.dec_previous_member == "yes") {

          if (!this.applicant1.dec_suspended) {

            this.applicant1.dec_suspended_error = true;
            this.error = true;
          } else {
            this.applicant1.dec_suspended_error = false;

            if (this.applicant1.dec_suspended == "yes") {

              if (!this.applicant1.dec_suspendedmsg) {

                this.applicant1.dec_suspendedmsg_error = true;
                this.error = true;
              } else {
                this.applicant1.dec_suspendedmsg_error = false;
              }
            }
          }
        }

        /* if (!this.applicant1.dec_party || this.applicant1.dec_party == "no") {
        this.applicant1.dec_party_error = true;
        this.error = true;
        }
        else {
        this.applicant1.dec_party_error = false;
        }
        if (!this.applicant1.dec_candidate || this.applicant1.dec_candidate == "no") {
        this.applicant1.dec_candidate_error = true;
        this.error = true;
        }
        else {
        this.applicant1.dec_candidate_error = false;
        }*/

        if (this.isJoint) {
          if (!this.applicant2.dec_prohibited_funding) {
            this.applicant2.dec_prohibited_funding_error = true;
            this.error = true;
          } else {
            this.applicant2.dec_prohibited_funding_error = false;
          }

          if (!this.applicant2.dec_lobbyist) {
            this.applicant2.dec_lobbyist_error = true;
            this.error = true;
          } else {
            this.applicant2.dec_lobbyist_error = false;
          }

          if (!this.applicant2.dec_previous_member) {
            this.applicant2.dec_previous_member_error = true;
            this.error = true;
          } else {
            this.applicant2.dec_previous_member_error = false;
          }

          if (this.applicant2.dec_previous_member == "yes") {
            if (!this.applicant2.dec_suspended) {

              this.applicant2.dec_suspended_error = true;
              this.error = true;
            } else {
              this.applicant2.dec_suspended_error = false;

              if (this.applicant2.dec_suspended == "yes") {

                if (!this.applicant2.dec_suspendedmsg) {

                  this.applicant2.dec_suspendedmsg_error = true;
                  this.error = true;
                } else {
                  this.applicant2.dec_suspendedmsg_error = false;
                }
              }
            }
          }

          /*if (!this.applicant2.dec_party || this.applicant2.dec_party == "no") {
        this.applicant2.dec_party_error = true;
        this.error = true;
        }
        else {
        this.applicant2.dec_party_error = false;
        }
        if (!this.applicant2.dec_candidate || this.applicant2.dec_candidate == "no") {
        this.applicant2.dec_candidate_error = true;
        this.error = true;
        }
        else {
        this.applicant2.dec_candidate_error = false;
        }*/
        }

        if (!this.error) {

          this.changePage(6);
        }
      }
      if (this.page == 4) {
        this.error = false;

        if (!this.applicant1.branch_type) {
          this.applicant1.branch_type_error = true;
          this.error = true;
        } else {
          this.applicant1.branch_type_error = false;
        }

        if (this.isJoint) {
          if (!this.applicant2.branch_type) {
            this.applicant2.branch_type_error = true;
            this.error = true;
          } else {
            this.applicant2.branch_type_error = false;
          }
        }

        if (this.applicant1.branch_type == "branch") {

          if (!this.applicant1.branch_code) {
            this.applicant1.branch_code_error = true;
            this.error = true;
          } else {
            this.applicant1.branch_code_error = false;
          }
        }

        if (this.isJoint) {

          if (this.applicant2.branch_type == "branch") {

            if (!this.applicant2.branch_code) {
              this.applicant2.branch_code_error = true;
              this.error = true;
            } else {
              this.applicant2.branch_code_error = false;
            }
          }
        }

        if (!this.error) {
          this.changePage(5);
        }
      }
      if (this.page == 3) {
        this.error = false;

        if (!this.applicant1.picked) {
          this.applicant1.picked_error = true;
          this.error = true;
        } else {
          this.applicant1.picked_error = false;
        }

        if (this.isJoint) {
          if (!this.applicant1.picked) {
            this.applicant1.picked_error = true;
            this.error = true;
          } else {
            this.applicant1.picked_error = false;
          }
        }

        if (this.applicant1.is_concession && !this.applicant1.files[0].blob) {
          this.applicant1.files[0].error = true;
          this.error = true;
        } else {
          this.applicant1.files[0].error = false;
        }

        if (this.isJoint) {
          if (this.applicant2.is_concession && !this.applicant2.files[0].blob) {
            this.applicant2.files[0].error = true;
            this.error = true;
          } else {
            this.applicant2.files[0].error = false;
          }
        }

        if (!this.error) {

          const nextPage = this.userIsTelemarketer ? 5 : 4;


          //show for all case
          this.changePage(nextPage);


          /*if (!this.isJoint && this.is_young_liberal) {
        this.applicant1.branch_type = "general";
        this.changePage(5);
        }
        else {
        this.changePage(4);
        }*/
        }
      }
      if (this.page == 2) {
        /*applicant 1*/
        this.error = false;
        if (!this.applicant1.dec_1) {
          this.applicant1.dec_1_error = true;
          this.error = true;
        } else {
          this.applicant1.dec_1_error = false;
        }

        if (!this.applicant1.dec_2) {

          this.applicant1.dec_2_error = true;
          this.error = true;
        } else {
          this.applicant1.dec_2_error = false;
        }

        if (this.isJoint) {
          /*applicant 2*/
          if (!this.applicant2.dec_1) {
            this.applicant2.dec_1_error = true;
            this.error = true;
          } else {
            this.applicant2.dec_1_error = false;
          }

          if (!this.applicant2.dec_2) {

            this.applicant2.dec_2_error = true;
            this.error = true;
          } else {
            this.applicant2.dec_2_error = false;
          }
        }

        if (!this.error) {
          this.changePage(3);
        }
      }
      if (this.page == 1) {
        this.error = false;

        /*applicant 1*/
        if (!this.applicant1.prefix) {
          this.applicant1.prefix_error = true;
          this.error = true;
        } else {
          this.applicant1.prefix_error = false;
        }

        if (!this.applicant1.first_name) {
          this.applicant1.first_name_error = true;
          this.error = true;
        } else {
          this.applicant1.first_name = this.applicant1.first_name.replace("�", "'");
          this.applicant1.first_name_error = false;
        }

        if (!this.applicant1.last_name) {
          this.applicant1.last_name_error = true;
          this.error = true;
        } else {
          this.applicant1.last_name = this.applicant1.last_name.replace("�", "'");
          this.applicant1.last_name_error = false;
        }

        if (!this.applicant1.date_of_birth) {
          this.applicant1.date_of_birth_error = true;
          this.error = true;
        } else {
          this.applicant1.date_of_birth_error = false;
        }

        // joint applicant basics
        if (this.isJoint) {
          /*applicant 2*/

          if (!this.applicant2.prefix) {
            this.applicant2.prefix_error = true;
            this.error = true;
          } else {
            this.applicant2.prefix_error = false;
          }

          if (!this.applicant2.first_name) {
            this.applicant2.first_name_error = true;
            this.error = true;
          } else {
            this.applicant2.first_name = this.applicant2.first_name.replace("�", "'");
            this.applicant2.first_name_error = false;
          }

          if (!this.applicant2.last_name) {
            this.applicant2.last_name_error = true;
            this.error = true;
          } else {
            this.applicant2.last_name = this.applicant2.last_name.replace("�", "'");
            this.applicant2.last_name_error = false;
          }

          /*if (!$('#applicant2_date_of_birth').find('input').first().val()) {
        this.applicant2.date_of_birth_error = true;
        this.error = true;
        } else {
        this.applicant2.date_of_birth_error = false;
        }*/

          if (!this.applicant2.date_of_birth) {
            this.applicant2.date_of_birth_error = true;
            this.error = true;
          } else {
            this.applicant2.date_of_birth_error = false;
          }
        }


        // validate email/mobile if not staff privileges
        if (!this.userIsStaff) {
          if (!this.applicant1.email) {
            this.applicant1.email_error = true;
            this.error = true;
          } else {
            if (!testEmail.test(this.applicant1.email)) {
              this.error = true;
              this.applicant1.email_error = true;
            } else {
              this.applicant1.email_error = false;
            }
          }

          if (!this.applicant1.mobile_phone) {
            this.applicant1.mobile_phone_error = true;
            this.error = true;
          } else {
            this.applicant1.mobile_phone_error = false;
          }
        }

        /* Elect address*/
        if (!this.applicant1.address.street_number) {
          this.applicant1.address.street_number_error = true;
          this.error = true;
        } else {
          this.applicant1.address.street_number_error = false;
        }

        if (!this.applicant1.address.street_name) {
          this.applicant1.address.street_name_error = true;
          this.error = true;
        } else {
          this.applicant1.address.street_name_error = false;
        }

        if (!this.applicant1.address.street_type) {
          this.applicant1.address.street_type_error = true;
          this.error = true;
        } else {
          this.applicant1.address.street_type_error = false;
        }

        if (!this.applicant1.address.suburb) {
          this.applicant1.address.suburb_error = true;
          this.error = true;
        } else {
          this.applicant1.address.suburb_error = false;
        }

        if (!this.applicant1.address.state) {

          this.applicant1.address.state_error = true;
          this.error = true;
        } else {
          this.applicant1.address.state_error = false;
        }
        if (!this.applicant1.address.post_code) {
          this.applicant1.address.post_code_error = true;
          this.error = true;
        } else {
          this.applicant1.address.post_code_error = false;
        }

        /* postal address*/
        if (!this.applicant1.postaladdress.use_pobox) {
          this.applicant1.postaladdress.address1 = "";
          if (!this.applicant1.postaladdress.street_number) {
            this.applicant1.postaladdress.street_number_error = true;
            this.error = true;
          } else {
            this.applicant1.postaladdress.street_number_error = false;
          }

          if (!this.applicant1.postaladdress.street_name) {
            this.applicant1.postaladdress.street_name_error = true;
            this.error = true;
          } else {
            this.applicant1.postaladdress.street_name_error = false;
          }

          if (!this.applicant1.postaladdress.street_type) {
            this.applicant1.postaladdress.street_type_error = true;
            this.error = true;
          } else {
            this.applicant1.postaladdress.street_type_error = false;
          }
        } else {
          if (!this.applicant1.postaladdress.address1) {
            this.applicant1.postaladdress.address1_error = true;
            this.error = true;
          } else {
            this.applicant1.postaladdress.address1_error = false;
          }
        }

        if (!this.applicant1.postaladdress.suburb) {
          this.applicant1.postaladdress.suburb_error = true;
          this.error = true;
        } else {
          this.applicant1.postaladdress.suburb_error = false;
        }

        if (!this.applicant1.postaladdress.state) {

          this.applicant1.postaladdress.state_error = true;
          this.error = true;
        } else {
          this.applicant1.postaladdress.state_error = false;
        }
        if (!this.applicant1.postaladdress.post_code) {
          this.applicant1.postaladdress.post_code_error = true;
          this.error = true;
        } else {
          this.applicant1.postaladdress.post_code_error = false;
        }
        /*applicant1-mob validate*/
        if (this.applicant1.mobile_phone) {
          // if (!this.applicant1.mobile_phone.indexOf('04') == 0 || this.applicant1.mobile_phone.length > 12 || !testMobno.test(this.applicant1.mobile_phone.replace(new RegExp(" ", 'g'), ""))) {
          if (!testMobno.test(this.applicant1.mobile_phone.replace(new RegExp(" ", 'g'), ""))) {
            this.applicant1.address.validate_errormob = true;
            this.error = true;
          } else {
            this.applicant1.address.validate_errormob = false;
          }
        }
        /*mob val end*/
        /*end*/

        if (this.isJoint) {
          /*applicant 2*/

          if (!this.userIsStaff) {

            if (!this.applicant2.email) {
              this.applicant2.email_error = true;
              this.error = true;
            } else {
              if (!testEmail.test(this.applicant2.email)) {
                this.error = true;
                this.applicant2.email_error = true;
              } else {
                this.applicant2.email_error = false;
              }
            }


            if (!this.applicant2.mobile_phone) {
              this.applicant2.mobile_phone_error = true;
              this.error = true;
            } else {
              this.applicant2.mobile_phone_error = false;
            }

          }


          if (!this.applicant2.address.street_number) {
            this.applicant2.address.street_number_error = true;
            this.error = true;
          } else {
            this.applicant2.address.street_number_error = false;
          }

          if (!this.applicant2.address.street_name) {
            this.applicant2.address.street_name_error = true;
            this.error = true;
          } else {
            this.applicant2.address.street_name_error = false;
          }

          if (!this.applicant2.address.street_type) {
            this.applicant2.address.street_type_error = true;
            this.error = true;
          } else {
            this.applicant2.address.street_type_error = false;
          }

          if (!this.applicant2.address.suburb) {
            this.applicant2.address.suburb_error = true;
            this.error = true;
          } else {
            this.applicant2.address.suburb_error = false;
          }

          if (!this.applicant2.address.state) {

            this.applicant2.address.state_error = true;
            this.error = true;
          } else {
            this.applicant2.address.state_error = false;
          }
          if (!this.applicant2.address.post_code) {
            this.applicant2.address.post_code_error = true;
            this.error = true;
          } else {
            this.applicant2.address.post_code_error = false;
          }

          /* postal address*/
          if (!this.applicant2.postaladdress.use_pobox) {
            this.applicant2.postaladdress.address1 = "";
            if (!this.applicant2.postaladdress.street_number) {
              this.applicant2.postaladdress.street_number_error = true;
              this.error = true;
            } else {
              this.applicant2.postaladdress.street_number_error = false;
            }

            if (!this.applicant2.postaladdress.street_name) {
              this.applicant2.postaladdress.street_name_error = true;
              this.error = true;
            } else {
              this.applicant2.postaladdress.street_name_error = false;
            }

            if (!this.applicant2.postaladdress.street_type) {
              this.applicant2.postaladdress.street_type_error = true;
              this.error = true;
            } else {
              this.applicant2.postaladdress.street_type_error = false;
            }
          } else {
            if (!this.applicant2.postaladdress.address1) {
              this.applicant2.postaladdress.address1_error = true;
              this.error = true;
            } else {
              this.applicant2.postaladdress.address1_error = false;
            }
          }

          if (!this.applicant2.postaladdress.suburb) {
            this.applicant2.postaladdress.suburb_error = true;
            this.error = true;
          } else {
            this.applicant2.postaladdress.suburb_error = false;
          }

          if (!this.applicant2.postaladdress.state) {

            this.applicant2.postaladdress.state_error = true;
            this.error = true;
          } else {
            this.applicant2.postaladdress.state_error = false;
          }
          if (!this.applicant2.postaladdress.post_code) {
            this.applicant2.postaladdress.post_code_error = true;
            this.error = true;
          } else {
            this.applicant2.postaladdress.post_code_error = false;
          }

          /*applicant1-mob validate*/
          if (this.applicant2.mobile_phone) {
            // if (!this.applicant2.mobile_phone.indexOf('04') == 0 || this.applicant2.mobile_phone.length > 12 || !testMobno.test(this.applicant2.mobile_phone.replace(new RegExp(" ", 'g'), ""))) {
            if (!testMobno.test(this.applicant2.mobile_phone.replace(new RegExp(" ", 'g'), ""))) {
              this.applicant2.address.validate_errormob = true;
              this.error = true;
            } else {
              this.applicant2.address.validate_errormob = false;
            }
          }
          /*mob val end*/

          /*end*/
        }

        if (!this.error) {
          this.applicant1.branches = null;
          this.applicant1.address.electorate = {valid: null, electorate_code: null, id: null};

          // bypass electoral role address validation if telemarketer using form
          this.userIsTelemarketer ? this.setTelemarketerValidation(this.applicant1) : this.getElectorateCode(this.applicant1)


          if (this.isJoint) {
            this.applicant2.branches = null;
            this.applicant2.address.electorate = {valid: null, electorate_code: null, id: null};

            // bypass electoral role address validation if telemarketer using form
            this.userIsTelemarketer ? this.setTelemarketerValidation(this.applicant2) : this.getElectorateCode(this.applicant2)
          }
        }

        /*if (!this.error) {
        this.changePage(2);
        }*/
      }
    },
    changePage: function changePage(page) {

      this.page = page;
      this.progress = {
        width: this.page / this.total_pages * 100 + '%'
      };
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    updateProducts: function updateProducts() {
      this.applicant1.products = [];
      this.applicant2.products = [];
      this.payment.membership.amount = 0;
      if (this.applicant1.picked) {
        for (var i = 0; i < this.products.length; i++) {

          for (var x in this.products[i]) {

            if (x == "product_code") {
              if (this.products[i][x] == this.applicant1.picked) {
                this.applicant1.products.push(this.products[i]);
                this.payment.membership.amount += parseFloat(this.products[i].price);

                if (this.products[i].is_concession) {
                  this.applicant1.is_concession = true;
                  //Age of the applicant is over 60 years then they are not required to upload proof of concession.
                  if (this.applicant1.years !== null && this.applicant1.years >= 60) {
                    this.applicant1.is_concession = false;
                  }
                } else {
                  this.applicant1.is_concession = false;
                }
              }
            }
          }
        }
      }
      if (this.isJoint) {
        if (this.applicant1.picked) {
          for (var i = 0; i < this.products.length; i++) {

            for (var x in this.products[i]) {

              if (x == "product_code") {
                if (this.products[i][x] == this.applicant1.picked) {
                  this.applicant2.products.push(this.products[i]);
                  this.payment.membership.amount += parseFloat(this.products[i].price);
                  if (this.products[i].is_concession) {
                    this.applicant2.is_concession = true;
                    //Age of the applicant is over 60 years then they are not required to upload proof of concession.
                    if (this.applicant2.years !== null && this.applicant2.years >= 60) {
                      this.applicant2.is_concession = false;
                    }
                  } else {
                    this.applicant2.is_concession = false;
                  }
                }
              }
            }
          }
        }
      }
      if (this.payment.donation.donation_amount && !isNaN(this.payment.donation.donation_amount)) {
        this.payment.membership.amount += parseFloat(this.payment.donation.donation_amount);
      }
    },
    updateSetDonation: function updateSetDonation(amount) {
      if (this.payment.donation.donation_amount == amount || amount == 0) {
        this.payment.donation.donation_amount = null;
        this.payment.donation.set_amount = false;
      } else {
        this.payment.donation.donation_amount = parseFloat(amount);
        this.payment.donation.set_amount = true;
      }

      this.updateProducts();
    },
    scrollToError: function scrollToError() {
      if ($('.input_error:first').length) {
        $('html, body').animate({
          scrollTop: $('.input_error:first').offset().top
        }, 300);
      }
    },

    sameAsAbove: function sameAsAbove() {
      this.applicant2.address.street_number = this.applicant1.address.street_number;
      this.applicant2.address.street_name = this.applicant1.address.street_name;
      this.applicant2.address.street_type = this.applicant1.address.street_type;
      this.applicant2.address.suburb = this.applicant1.address.suburb;
      this.applicant2.address.state = this.applicant1.address.state;
      this.applicant2.address.post_code = this.applicant1.address.post_code;
    },
    sameAsElect_Applicant1: function sameAsElect_Applicant1() {
      this.applicant1.postaladdress.street_number = this.applicant1.address.street_number;
      this.applicant1.postaladdress.street_name = this.applicant1.address.street_name;
      this.applicant1.postaladdress.street_type = this.applicant1.address.street_type;
      this.applicant1.postaladdress.suburb = this.applicant1.address.suburb;
      this.applicant1.postaladdress.state = this.applicant1.address.state;
      this.applicant1.postaladdress.post_code = this.applicant1.address.post_code;
    },
    sameAsElect_Applicant2: function sameAsElect_Applicant2() {
      this.applicant2.postaladdress.street_number = this.applicant2.address.street_number;
      this.applicant2.postaladdress.street_name = this.applicant2.address.street_name;
      this.applicant2.postaladdress.street_type = this.applicant2.address.street_type;
      this.applicant2.postaladdress.suburb = this.applicant2.address.suburb;
      this.applicant2.postaladdress.state = this.applicant2.address.state;
      this.applicant2.postaladdress.post_code = this.applicant2.address.post_code;
    },
    fileSelected: function fileSelected(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0], e);
    },
    createImage: function createImage(file, obj) {
      var _this7 = this;

      var image = new Image();
      var reader = new FileReader();

      if (obj.target.id == "applicant1_concession") {
        reader.onload = function (e) {
          _this7.applicant1.files[0].blob = e.target.result;
        };
      }
      if (obj.target.id == "applicant1_identity") {
        reader.onload = function (e) {
          _this7.applicant1.files[1].blob = e.target.result;
        };
      }

      if (obj.target.id == "applicant2_concession") {
        reader.onload = function (e) {
          _this7.applicant2.files[0].blob = e.target.result;
        };
      }
      if (obj.target.id == "applicant2_identity") {
        reader.onload = function (e) {
          _this7.applicant2.files[1].blob = e.target.result;
        };
      }

      reader.readAsDataURL(file);
    },

    // assign automatic validation for various fields when telemarketer is processing page 1 of form
    setTelemarketerValidation(applicant) {

      // set empty strings for values not handled by telemarketer
      applicant.id = ''
      applicant.feedbackid = ''

      // empty array to force general membership
      applicant.branches = []

      // valid
      applicant.address.electorate.valid = true

      // set errors to false
      applicant.address.validate_errormob = false
      applicant.address.validate_errorelectoral2 = false
      applicant.address.validate_error = false
      applicant.address.validate_duplicate = false
    }
  }
};
</script>

<style scoped lang="scss">
select.form-control {
  margin: 0;
}
</style>